<template>
  <div
    style="position:fixed;top:0;left:0;width:100%;height:100%;min-width: 1000px;overflow-y:auto"
    class="body"
  >
    <div class="head">
      <h1>蔚动力智慧充电运营管理平台</h1>
      <div id="showTime" class="time">{{ nowTime }}</div>
    </div>
    <div class="mainbox">
      <ul class="clearfix">
        <li>
          <div class="boxall" style="height: 20%">
            <div v-if="orgType == 1 || orgType == 2" class="alltitle">
              今日总览
            </div>
            <div v-if="orgType == 0 || orgType == 3" class="alltitle">
              今日总览（电站）
            </div>
            <div class="sycm sycmx">
              <ul class="clearfix">
                <li>
                  <h2 v-if="orgType == 0">
                    {{ getFixed2(formData.todayPower) }}
                  </h2>
                  <h2 v-if="orgType == 1 || orgType == 2">
                    {{ getFixed2(formData1.todayPower) }}
                  </h2>
                  <h2 v-if="orgType == 3">
                    {{ getFixed2(formData22.todayPower) }}
                  </h2>
                  <span>今日充电电量（度）</span>
                </li>
                <li>
                  <h2 v-if="orgType == 0">
                    {{ getFixed2(formData.todayMoney) }}
                  </h2>
                  <h2 v-if="orgType == 1 || orgType == 2">
                    {{ getFixed2(formData1.todayMoney) }}
                  </h2>
                  <h2 v-if="orgType == 3">
                    {{ getFixed2(formData22.todayMoney) }}
                  </h2>
                  <span>今日充电收入（元）</span>
                </li>
              </ul>
            </div>
            <div class="boxfoot" />
          </div>
          <div
            v-if="orgType == 0 || orgType == 3"
            class="boxall"
            style="height: 70%"
          >
            <div class="alltitle">电站排名</div>
            <div class="station-wrap">
              <table>
                <tr>
                  <th></th>
                  <th style="width:130px">站点</th>
                  <th>昨日充电量(度)</th>
                  <th>今日充电量(度)</th>
                </tr>
                <template v-for="(item, index) in stationNumArr">
                  <tr v-show="index < 8" :key="index">
                    <td>
                      <span>{{ index + 1 }}</span>
                    </td>
                     <el-tooltip class="item" effect="dark" :content="item.stationName" placement="top-start">
                    <td style="text-align: left;overflow: hidden;text-overflow:ellipsis;white-space:nowrap;display:inline-block;width:130px;">{{ item.stationName.indexOf('柚子充')!=-1?item.stationName.replace('柚子充',''): item.stationName}}</td>
                        </el-tooltip>
                    <td>{{ getFixed2(item.totalPower) }}</td>
                    <td>{{ getFixed2(item.todayTotalPower) }}</td>
                  </tr>
                </template>
              </table>
            </div>
            <div class="boxfoot" />
          </div>
          <div
            v-if="orgType == 1 || orgType == 2"
            class="boxall"
            style="height: 70%"
          >
            <div class="alltitle">用户消费排名</div>
            <div class="station-wrap less">
              <table>
                <tr>
                  <th>排名</th>
                  <th>用户</th>
                  <th>充电量</th>
                  <th>消费金额</th>
                </tr>
                <template v-for="(item, index) in topFiveConsumerList">
                  <tr v-show="index < 5" :key="index">
                    <td>
                      <span>{{ index + 1 }}</span>
                    </td>
                    <td>{{ item.loginName }}</td>
                    <td>{{ getFixed2(item.totalPower) }}度</td>
                    <td>{{ getFixed2(item.totalMoneyActual) }}元</td>
                  </tr>
                </template>
              </table>
            </div>
            <div class="boxfoot" />
          </div>
        </li>
        <li>
          <div style="position: relative;">
            <div class="barnav">
              <div class="bar">
                <div class="barbox">
                  <ul class="clearfix" style="display:flex;">
                    <li
                      v-if="orgType == 1 || orgType == 2"
                      class="pulll_left counter"
                    >
                      {{ formData1.totalOrderCount }}
                    </li>
                    <li
                      v-if="orgType == 1 || orgType == 2"
                      class="pulll_left counter"
                    >
                      {{ formData1.todayOrderCount }}
                    </li>
                    <li
                      v-if="orgType == 3 || orgType == 0"
                      class="pulll_left counter"
                    >
                      {{ stationCount }}
                    </li>
                    <li
                      v-if="orgType == 3 || orgType == 0"
                      class="pulll_left counter"
                    >
                      {{ pileCount }}
                    </li>
                    <li v-if="orgType == 3" class="pulll_left counter">
                      {{ formData2.totalOrderCount }}
                    </li>
                    <li v-if="orgType == 3" class="pulll_left counter">
                      {{ formData2.todayOrderCount }}
                    </li>
                    <li v-if="orgType == 0" class="pulll_left counter">
                      {{ formData.totalOrderCount }}
                    </li>
                    <li v-if="orgType == 0" class="pulll_left counter">
                      {{ formData.todayOrderCount }}
                    </li>
                  </ul>
                </div>
                <div class="barbox2">
                  <ul class="clearfix" style="display:flex;">
                    <li
                      v-if="orgType == 0 || orgType == 3"
                      class="pulll_left counter"
                    >
                      电站数
                    </li>
                    <li
                      v-if="orgType == 0 || orgType == 3"
                      class="pulll_left counter"
                    >
                      终端数
                    </li>
                    <li class="pulll_left counter">订单总数</li>
                    <li class="pulll_left counter">当日订单数</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="mapbox">
            <div class="map">
              <div class="map1"><img src="@/assets/lbx.png" /></div>
              <div class="map2"><img src="@/assets/jt.png" /></div>
              <div class="map3"><img src="@/assets/map.png" /></div>
              <div id="map_1" class="map4" />
            </div>
          </div>
        </li>
        <li v-if="orgType == 0 || orgType == 3">
          <div class="boxall" style="height: 70%">
            <div class="alltitle">历史总览（电站）</div>
            <div class="sycm sycm2">
              <ul class="clearfix">
                <li>
                  <!-- <h2 v-if="orgType == 0">{{ getFloat(formData.totalPower) }}</h2>
                  <h2 v-if="orgType == 3">{{ getFloat(formData22.totalPower) }}</h2> -->
                  <h2 v-if="orgType == 0">{{ formData.totalPower }}</h2>
                  <h2 v-if="orgType == 3">{{ formData22.totalPower }}</h2>
                  <span>累计充电度数（度）</span>
                </li>
                <li>
                  <h2 v-if="orgType == 0">{{ formData.totalMoney }}</h2>
                  <h2 v-if="orgType == 3">{{ formData22.totalMoney }}</h2>
                  <span>累计充电金额（元）</span>
                </li>
                <li>
                  <h2 v-if="orgType == 0">{{ formData.chargeCount }}</h2>
                  <h2 v-if="orgType == 3">{{ formData22.chargeCount }}</h2>
                  <span>累计充电次数（次）</span>
                </li>

                <li>
                  <h2 v-if="orgType == 0">{{ formData.chargeTime }}</h2>
                  <h2 v-if="orgType == 3">{{ formData22.chargeTime }}</h2>
                  <span>累计充电时长（小时）</span>
                </li>
              </ul>
            </div>
            <div class="boxfoot" />
          </div>
          <div class="boxall" style="height: 20%">
            <div
              class="alltitle"
              style="display: flex; justify-content: space-between;"
            >
              <div>降低碳排放量（kg）</div>
              <div style="margin-right: 30px;">相当于植树（棵）</div>
            </div>
            <div class="carbon-wrap">
              <span
                style="display: flex;align-items:center;width: 100%;justify-content: space-between;"
              >
                <div style="display: flex;align-items:center;">
                  <img
                    class="carbon-image"
                    src="../assets/carbonEmission.png"
                    alt=""
                  />
                  <span v-if="orgType == 0" class="carbon-value">{{
                    formData.carbonEmissions
                  }}</span>
                  <span v-if="orgType == 3" class="carbon-value">{{
                    formData22.carbonEmissions
                  }}</span>
                </div>
                <div style="display: flex;align-items:center;">
                  <img class="tree-image" src="../assets/tree.png" alt="" />
                  <span v-if="orgType == 0" class="tree-agv">{{
               formData.carbonEmissions?Math.ceil(formData.carbonEmissions / 5.023 / 365):''
                  }}</span>
                  <span v-if="orgType == 3" class="tree-agv">{{
                    formData22.carbonEmissions? Math.ceil(formData22.carbonEmissions / 5.023 / 365):''
                  }}</span>
                </div>
              </span>
            </div>
            <div class="boxfoot" />
          </div>
        </li>
        <li v-if="orgType == 1 || orgType == 2">
          <div class="boxall" style="height: 30%">
            <div class="alltitle">账户总览</div>
            <div class="sycm">
              <ul class="clearfix">
                <li>
                  <h2>{{ getFixed2(formData1.totalChargingMoney) }}</h2>
                  <span>累计充值金额（元）</span>
                </li>
                <li>
                  <h2>{{ getFixed2(formData1.totalPersonalMoney) }}</h2>
                  <span>账户余额（元）</span>
                </li>
              </ul>
            </div>
            <div class="boxfoot" />
          </div>
          <div class="boxall" style="height: 60%">
            <div class="alltitle">历史总览</div>
            <div class="sycm sycm2">
              <ul class="clearfix">
                <li>
                  <h2>{{ formData1.totalPower }}</h2>
                  <!-- <h2>{{ getFloat(formData1.totalPower) }}</h2> -->
                  <span>累计充电度数（度）</span>
                </li>
                <li>
                  <h2>{{ formData1.totalMoney }}</h2>
                  <span>累计充电金额（元）</span>
                </li>
                <li>
                  <h2>{{ formData1.chargeCount }}</h2>
                  <span>累计充电次数（次）</span>
                </li>

                <li>
                  <h2>{{ formData1.chargeTime }}</h2>
                  <span>累计充电时长（小时）</span>
                </li>
              </ul>
            </div>
            <div class="boxfoot" />
          </div>
        </li>
      </ul>
    </div>
    <div v-show="orgType == 0">
      <div class="mainbox2">
        <ul class="clearfix" style="display:flex">
          <li style="width:34%">
            <div class="boxall" style="height: 100%">
              <div class="alltitle">充电终端监控</div>
              <div class="boxnav">
                <ul class="btbox">
                  <li id="bt01" />
                  <li id="bt02" />
                  <li id="bt03" />
                </ul>
              </div>
              <div class="boxfoot" />
            </div>
          </li>
          <li style="width:34%">
            <div class="boxall" style="height: 100%">
              <div class="alltitle">近十日电站充电订单量</div>
              <div id="echart04" class="boxnav" style="height:160px" />
              <div class="boxfoot" />
            </div>
          </li>
          <li style="width:34%">
            <div class="boxall" style="height: 220px">
              <div class="alltitle">当日实时充电分布</div>
              <div id="echart05" class="boxnav" style="height:170px" />
              <div class="boxfoot" />
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div v-show="orgType == 1 || orgType == 2">
      <div class="mainbox2">
        <ul class="clearfix" style="display:flex">
          <li>
            <div class="boxall" style="height: 100%">
              <div class="alltitle">昨日充电汇总</div>
              <ul class="yesterday-wrap">
                <li>
                  <p>
                    <img
                      v-if="formData1.zrcdjehb < 0"
                      src="../assets/u300.png"
                      alt=""
                    />
                    <img v-else src="../assets/u304.png" alt="" />
                    <span>{{ formData1.zrcdjehb }}</span>
                  </p>
                  <p>昨日充电金额环比</p>
                </li>
                <li>
                  <p>
                    <img
                      v-if="formData1.zrcdschb < 0"
                      src="../assets/u301.png"
                      alt=""
                    />
                    <img v-else src="../assets/u305.png" alt="" />
                    <span>{{ formData1.zrcdschb }}</span>
                  </p>
                  <p>昨日充电时长环比</p>
                </li>
                <li>
                  <p>
                    <img
                      v-if="formData1.zrcddshb < 0"
                      src="../assets/u302.png"
                      alt=""
                    />
                    <img v-else src="../assets/u306.png" alt="" />
                    <span>{{ formData1.zrcddshb }}</span>
                  </p>
                  <p>昨日充电度数环比</p>
                </li>
                <li>
                  <p>
                    <img
                      v-if="formData1.zrcdcshb < 0"
                      src="../assets/u303.png"
                      alt=""
                    />
                    <img v-else src="../assets/u307.png" alt="" />
                    <span>{{ formData1.zrcdcshb }}</span>
                  </p>
                  <p>昨日充电次数环比</p>
                </li>
              </ul>
              <div class="boxfoot" />
            </div>
          </li>
          <li>
            <div class="boxall" style="height: 100%">
              <div class="alltitle">近十天用户充电度数</div>
              <div id="echart14" class="boxnav" style="height:160px;" />
              <div class="boxfoot" />
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div v-show="orgType == 3">
      <div class="mainbox2">
        <ul class="clearfix" style="display:flex">
          <li style="width:34%">
            <div class="boxall" style="height: 100%">
              <div class="alltitle">充电终端监控</div>
              <div class="boxnav">
                <ul class="btbox">
                  <li id="bt31" />
                  <li id="bt32" />
                  <li id="bt33" />
                </ul>
              </div>
              <div class="boxfoot" />
            </div>
          </li>
          <li style="width:34%">
            <div class="boxall" style="height: 100%">
              <div class="alltitle">近十天用户充电度数</div>
              <div id="echart34" class="boxnav" style="height:170px" />
              <div class="boxfoot" />
            </div>
          </li>
          <li style="width:34%">
            <div class="boxall" style="height: 220px">
              <div class="alltitle">当日实时充电分布（{{ todayTime }}）</div>
              <div id="echart35" class="boxnav" style="height:170px" />
              <div class="boxfoot" />
            </div>
          </li>
        </ul>
      </div>
    </div>

    <!-- <div class="copyright"> -->
    <!-- 版权所有：深圳市深海时代网络科技有限公司 粤ICP备15031517号-4 -->
    <!-- </div> -->
    <div
      class="header-user-con"
      style="position:absolute;top:20px;right:40px;width:30px;height:30px;cursor: pointer;"
      @click="close"
    >
      <img src="@/assets/switch.png" alt="" style="width:100%;height:100%" />
    </div>
  </div>
</template>

<script>
// import JSON from '../city/100000.json'  //中国地图
import JSON from "../city/320100.json"; //南京地图
import Moment from "moment";
export default {
  name: "BigScreen",
  components: {},
  data() {
    return {
      nowTime: new Date(),
      todayTime: "",
      timer: null,
      timer2:null,
      echartsTimer: null,
      echartsTimer1: null,
      stationCount: 0, // 电站数
      pileCount: 0, // 终端数
      mapList: [], // 地图

      orgType: 0, // 视角
      chartsDataX: [], // 近十日用户充电费用x轴
      chartsDataY: [], // 近十日用户充电费用y轴
      chartsData1X: [], // 当日实时充电分布x轴
      xData: [],
      chartsData1Y: [], // 当日实时充电分布y轴

      formData: {}, // orgType 为0时 今日总览和历史总览

      formData1: {}, // orgType 为1和2时 今日总览和历史总览

      formData2: {}, // orgType 为3时 今日总览和历史总览 用户

      formData22: {}, // 今日总览和历史总览 电站

      chargingPercent: "",
      freePercent: "",
      faultPercent: "",
      stationNumArr: [],
      topFiveConsumerList: []
    };
  },
  computed: {},
  created() {
    this.$store.dispatch("login/getCur");
    // console.log(Math.ceil("1.03"));
  },
  mounted() {
    const _this = this; // 声明一个变量指向Vue实例this，保证作用域一致
    if (_this.orgType === 0) {
      this.map();
      // this.bt01();
      // this.bt02();
      // this.bt03();
      // this.echarts_04();
      // this.echarts_05();
    } else if (_this.orgType === 1 || _this.orgType === 2) {
      // this.echarts_14();
      // this.map();
    } else if (_this.orgType === 3) {
      // this.map();
      // this.echarts_34();
      // this.echarts_35();
      // this.bt31();
      // this.bt32();
      // this.bt33();
    }
    this.timer = setInterval(() => {
      _this.nowTime = _this.dateFormat(new Date()); // 修改数据date
    }, 1000);
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {
    this.$store.dispatch("form/handle", {
      url: "/user/login/getCurInfo",
      callback: resp => {
        const companyId = resp.companyId;
        //---- 订单总数和当日订单数
        this.$store.dispatch("form/handle", {
          url: "/finance/screen/overviewByOrderByStation",
          data: {
            companyId: companyId,
            loading:false
          },
          method: "get",
          callback: resp => {
            localStorage.setItem("orgType", resp.orgType);
            this.orgType = resp.orgType;
            if (resp.orgType === 0) {
              this.formData.totalOrderCount = resp.stationResp.totalOrderCount;
              this.formData.todayOrderCount = resp.stationResp.todayOrderCount;
            } else if (resp.orgType === 1 || resp.orgType === 2) {
              // this.formData1.totalOrderCount = resp.stationResp.totalOrderCount;
              // this.formData1.todayOrderCount = resp.stationResp.todayOrderCount;
            } else if (resp.orgType === 3) {
              this.formData22.totalOrderCount = resp.stationResp.totalOrderCount;
              this.formData22.todayOrderCount = resp.stationResp.todayOrderCount;
            }
          }
        });
        //----
                this.$store.dispatch("form/handle", {
          url: "/finance/screen/overviewByOrderByAccount",
          data: {
            companyId: companyId,
            loading:false
          },
          method: "get",
          callback: resp => {
            localStorage.setItem("orgType", resp.orgType);
            this.orgType = resp.orgType;
            if (resp.orgType === 0) {
              // this.formData.totalOrderCount = resp.stationResp.totalOrderCount;
              // this.formData.todayOrderCount = resp.stationResp.todayOrderCount;
            } else if (resp.orgType === 1 || resp.orgType === 2) {
              this.formData1.totalOrderCount = resp.accountResp.totalOrderCount;
              this.formData1.todayOrderCount = resp.accountResp.todayOrderCount;
            } else if (resp.orgType === 3) {
              this.formData2.totalOrderCount = resp.accountResp.totalOrderCount;
              this.formData2.todayOrderCount = resp.accountResp.todayOrderCount;
            }
          }
        });
        // ----今日总览和历史总览
        this.$store.dispatch("form/handle", {
          url: "/finance/screen/overviewByLookByStation",
          data: {
            companyId: companyId,
            loading:false
          },
          method: "get",
          callback: resp => {
            const totalPower = resp.stationResp.totalPower;
            const totalMoney = resp.stationResp.totalMoney;
            const chargeCount = resp.stationResp.chargeCount;
            const chargeTime = resp.stationResp.chargeTime;
            if (resp.orgType === 0) {
              this.formData.todayPower = resp.stationResp.todayPower;
              this.formData.todayMoney = resp.stationResp.todayMoney;
              this.formData.carbonEmissions = resp.stationResp.carbonEmissions;
              // 如果数字没超过万，就直接保留两位小数；否则就大额转为数字+单位，如356214转为35.62万，保留两位小数
              this.formData.totalPower =
                this.strNumSize(totalPower) < 5
                  ? this.retain2(totalPower)
                  : this.unitConvert(totalPower).num +
                    this.unitConvert(totalPower).unit;
              this.formData.totalMoney =
                this.strNumSize(totalMoney) < 5
                  ? this.retain2(totalMoney)
                  : this.unitConvert(totalMoney).num +
                    this.unitConvert(totalMoney).unit;
              this.formData.chargeCount =
                this.strNumSize(chargeCount) < 5
                  ? this.retain2(chargeCount)
                  : this.unitConvert(chargeCount).num +
                    this.unitConvert(chargeCount).unit;
              this.formData.chargeTime =
                this.strNumSize(chargeTime) < 5
                  ? this.retain2(chargeTime)
                  : this.unitConvert(chargeTime).num +
                    this.unitConvert(chargeTime).unit;
            } else if (resp.orgType === 1 || resp.orgType === 2) {
              // this.formData1.todayPower = resp.stationResp.todayPower;
              // this.formData1.todayMoney = resp.stationResp.todayMoney;
              // this.formData1.carbonEmissions = resp.stationResp.carbonEmissions;
              // // 如果数字没超过万，就直接保留两位小数；否则就大额转为数字+单位，如356214转为35.62万，保留两位小数
              // this.formData1.totalPower =
              //   this.strNumSize(totalPower) < 5
              //     ? this.retain2(totalPower)
              //     : this.unitConvert(totalPower).num +
              //       this.unitConvert(totalPower).unit;
              // this.formData1.totalMoney =
              //   this.strNumSize(totalMoney) < 5
              //     ? this.retain2(totalMoney)
              //     : this.unitConvert(totalMoney).num +
              //       this.unitConvert(totalMoney).unit;
              // this.formData1.chargeCount =
              //   this.strNumSize(chargeCount) < 5
              //     ? this.retain2(chargeCount)
              //     : this.unitConvert(chargeCount).num +
              //       this.unitConvert(chargeCount).unit;
              // this.formData1.chargeTime =
              //   this.strNumSize(chargeTime) < 5
              //     ? this.retain2(chargeTime)
              //     : this.unitConvert(chargeTime).num +
              //       this.unitConvert(chargeTime).unit;
            } else if (resp.orgType === 3) {
              this.formData22.carbonEmissions =
                resp.stationResp.carbonEmissions;
              this.formData22.todayPower = resp.stationResp.todayPower;
              this.formData22.todayMoney = resp.stationResp.todayMoney;
              // 如果数字没超过万，就直接保留两位小数；否则就大额转为数字+单位，如356214转为35.62万，保留两位小数
              this.formData22.totalPower =
                this.strNumSize(totalPower) < 5
                  ? this.retain2(totalPower)
                  : this.unitConvert(totalPower).num +
                    this.unitConvert(totalPower).unit;
              this.formData22.totalMoney =
                this.strNumSize(totalMoney) < 5
                  ? this.retain2(totalMoney)
                  : this.unitConvert(totalMoney).num +
                    this.unitConvert(totalMoney).unit;
              this.formData22.chargeCount =
                this.strNumSize(chargeCount) < 5
                  ? this.retain2(chargeCount)
                  : this.unitConvert(chargeCount).num +
                    this.unitConvert(chargeCount).unit;
              this.formData22.chargeTime =
                this.strNumSize(chargeTime) < 5
                  ? this.retain2(chargeTime)
                  : this.unitConvert(chargeTime).num +
                    this.unitConvert(chargeTime).unit;
            }
          }
        });
        //----
                this.$store.dispatch("form/handle", {
          url: "/finance/screen/overviewByLookByAccount",
          data: {
            companyId: companyId,
            loading:false
          },
          method: "get",
          callback: resp => {
            const totalPower = resp.accountResp.totalPower;
            const totalMoney = resp.accountResp.totalMoney;
            const chargeCount = resp.accountResp.chargeCount;
            const chargeTime = resp.accountResp.chargeTime;
            if (resp.orgType === 0) {
            } else if (resp.orgType === 1 || resp.orgType === 2) {
              this.formData1.todayPower = resp.accountResp.todayPower;
              this.formData1.todayMoney = resp.accountResp.todayMoney;
              this.formData1.carbonEmissions = resp.accountResp.carbonEmissions;
              // 如果数字没超过万，就直接保留两位小数；否则就大额转为数字+单位，如356214转为35.62万，保留两位小数
              this.formData1.totalPower =
                this.strNumSize(totalPower) < 5
                  ? this.retain2(totalPower)
                  : this.unitConvert(totalPower).num +
                    this.unitConvert(totalPower).unit;
              this.formData1.totalMoney =
                this.strNumSize(totalMoney) < 5
                  ? this.retain2(totalMoney)
                  : this.unitConvert(totalMoney).num +
                    this.unitConvert(totalMoney).unit;
              this.formData1.chargeCount =
                this.strNumSize(chargeCount) < 5
                  ? this.retain2(chargeCount)
                  : this.unitConvert(chargeCount).num +
                    this.unitConvert(chargeCount).unit;
              this.formData1.chargeTime =
                this.strNumSize(chargeTime) < 5
                  ? this.retain2(chargeTime)
                  : this.unitConvert(chargeTime).num +
                    this.unitConvert(chargeTime).unit;
            } else if (resp.orgType === 3) {
              this.formData2.carbonEmissions =
                resp.accountResp.carbonEmissions;
              this.formData2.todayPower = resp.accountResp.todayPower;
              this.formData2.todayMoney = resp.accountResp.todayMoney;
              // 如果数字没超过万，就直接保留两位小数；否则就大额转为数字+单位，如356214转为35.62万，保留两位小数
              this.formData2.totalPower =
                this.strNumSize(totalPower) < 5
                  ? this.retain2(totalPower)
                  : this.unitConvert(totalPower).num +
                    this.unitConvert(totalPower).unit;
              this.formData2.totalMoney =
                this.strNumSize(totalMoney) < 5
                  ? this.retain2(totalMoney)
                  : this.unitConvert(totalMoney).num +
                    this.unitConvert(totalMoney).unit;
              this.formData2.chargeCount =
                this.strNumSize(chargeCount) < 5
                  ? this.retain2(chargeCount)
                  : this.unitConvert(chargeCount).num +
                    this.unitConvert(chargeCount).unit;
              this.formData2.chargeTime =
                this.strNumSize(chargeTime) < 5
                  ? this.retain2(chargeTime)
                  : this.unitConvert(chargeTime).num +
                    this.unitConvert(chargeTime).unit;
            }
          }
        });
        //---- 电站排名+充电终端监控
        this.$store.dispatch("form/handle", {
          url: "/finance/screen/overview",
          data: {
            companyId: companyId,
            loading:false
          },
          method: "get",
          callback: resp => {
            if (resp.orgType === 0) {
              this.stationNumArr = resp.stationResp.topTenList;
              for (var i = 0; i < resp.stationResp.stationResp.length; i++) {
                this.pileCount +=
                  resp.stationResp.stationResp[i].acCount +
                  resp.stationResp.stationResp[i].dcCount;
              }
              this.stationCount = resp.stationResp.stationResp.length;
              if (resp.stationResp.stationResp.length > 0) {
                this.mapList = resp.stationResp.stationResp;
              } else {
                this.mapList = [];
              }
              if(this.mapList.length>0){
                              this.map();
              }
                  this.chargingPercent = resp.stationResp.chargingPercent;
                this.freePercent = resp.stationResp.freePercent;
                this.faultPercent = resp.stationResp.faultPercent;
                if(this.chargingPercent){
                         this.bt01();    
                }
                if(this.freePercent){
                  this.bt02();
                }
                if(this.faultPercent){
                    this.bt03();
                }
            } else if (resp.orgType === 1 || resp.orgType === 2) {
              // this.mapList = resp.accountResp.mapList;
              // this.map();
            } else if (resp.orgType === 3) {
              this.stationNumArr = resp.stationResp.topTenList;
              for (let i = 0; i < resp.stationResp.stationResp.length; i++) {
                this.pileCount +=
                  resp.stationResp.stationResp[i].acCount +
                  resp.stationResp.stationResp[i].dcCount;
              }
              this.stationCount = resp.stationResp.stationResp.length;
              this.mapList = resp.stationResp.stationResp;
              if(this.mapList.length>0){
                            this.map();
              }
                              this.chargingPercent = resp.stationResp.chargingPercent
                this.freePercent = resp.stationResp.freePercent
                this.faultPercent = resp.stationResp.faultPercent
                if(this.chargingPercent){
                  this.bt31()
                }
               if(this.freePercent){
                  this.bt32()
               }
             if( this.faultPercent){
              this.bt33()
             }
              
            }
          }
        });
        //------map
                        this.$store.dispatch("form/handle", {
          url: "/finance/screen/overviewByMapByAccount",
          data: {
            companyId: companyId,
            loading:false
          },
          method: "get",
          callback: resp => {
            if (resp.orgType === 0) {
            } else if (resp.orgType === 1 || resp.orgType === 2) {
              this.mapList = resp.accountResp.mapList;
              if(this.mapList.length>0){
                          this.map();
              }
            
            } else if (resp.orgType === 3) {
            }
          }
        });
        //----近十天用户充电度数
            this.$store.dispatch("form/handle", {
          url: "/finance/screen/overviewByTop10ByStation",
          data: {
            companyId: companyId,
            loading:false
          },
          method: "get",
          callback: resp => {
            if (resp.orgType === 0) {
                  this.chartsDataX = resp.stationResp.xAxisDate;
                this.chartsDataY = resp.stationResp.yAxisCount;
                                for (let i = 0; i < this.chartsDataY.length; i++) {
                  this.chartsDataY[i] = this.getFloat(this.chartsDataY[i])
                }
                if( this.chartsDataX&& this.chartsDataX.length>0){
                                        this.echarts_04()
                }
            } else if (resp.orgType === 1 || resp.orgType === 2) {
                //        this.chartsDataX = resp.accountResp.xAxisDate;
                // this.chartsDataY = resp.accountResp.yAxisCount;
                //   for (let i = 0; i < this.chartsDataY.length; i++) {
                //   this.chartsDataY[i] = this.getFloat(this.chartsDataY[i])
                // }
                //   this.echarts_14()
            } else if (resp.orgType === 3) {
            //      this.chartsDataX = resp.accountResp.xAxisDate
            //     this.chartsDataY = resp.accountResp.yAxisCount
            //       for (let i = 0; i < this.chartsDataY.length; i++) {
            //       this.chartsDataY[i] = this.getFloat(this.chartsDataY[i])
            //     }
            //          this.echarts_34()
            }
          }
        });
        //----------------------------
                    this.$store.dispatch("form/handle", {
          url: "/finance/screen/overviewByTop10ByAccount",
          data: {
            companyId: companyId,
            loading:false
          },
          method: "get",
          callback: resp => {
            if (resp.orgType === 0) {
                //   this.chartsDataX = resp.stationResp.xAxisDate;
                // this.chartsDataY = resp.stationResp.yAxisCount;
                //                 for (let i = 0; i < this.chartsDataY.length; i++) {
                //   this.chartsDataY[i] = this.getFloat(this.chartsDataY[i])
                // }
                // this.echarts_04()
            } else if (resp.orgType === 1 || resp.orgType === 2) {
                       this.chartsDataX = resp.accountResp.xAxisDate;
                this.chartsDataY = resp.accountResp.yAxisCount;
                  for (let i = 0; i < this.chartsDataY.length; i++) {
                  this.chartsDataY[i] = this.getFloat(this.chartsDataY[i])
                }
                  if( this.chartsDataX&& this.chartsDataX.length>0){
                                    this.echarts_14()
                  }
            } else if (resp.orgType === 3) {
                 this.chartsDataX = resp.accountResp.xAxisDate
                this.chartsDataY = resp.accountResp.yAxisCount
                  for (let i = 0; i < this.chartsDataY.length; i++) {
                  this.chartsDataY[i] = this.getFloat(this.chartsDataY[i])
                }
                                  if( this.chartsDataX&& this.chartsDataX.length>0){
                                                      this.echarts_34()
                  }
                
            }
          }
        });
        //----当日实时充电分布
               this.$store.dispatch("form/handle", {
          url: "/finance/screen/overviewByTodayByStation",
          data: {
            companyId: companyId,
            loading:false
          },
          method: "get",
          callback: resp => {
            if (resp.orgType === 0) {
                this.chartsData1X = resp.stationResp.xTodayDate
                this.chartsData1Y = resp.stationResp.yTodayCount
                  if( this.chartsData1X && this.chartsData1X.length>0 ){
                                      this.echarts_05()
                  }

            } else if (resp.orgType === 1 || resp.orgType === 2) {
            } else if (resp.orgType === 3) {
              this.chartsData1X = resp.stationResp.xTodayDate
                this.chartsData1Y = resp.stationResp.yTodayCount
                if( this.chartsData1X && this.chartsData1X.length>0 ){
                this.echarts_35()
                }
            }
          }
        });
        //--------------
               this.$store.dispatch("form/handle", {
          url: "/finance/screen/overviewByQQBByAccount",
          data: {
            companyId: companyId,
            loading:false
          },
          method: "get",
          callback: resp => {
            if (resp.orgType === 0) {

            } else if (resp.orgType === 1 || resp.orgType === 2) {
               // 昨日充电金额环比
                   this.formData1.zrcdjehb = resp.accountResp.totalMoneyQOQ.toFixed(2) + '%'
                // 昨日充电时长环比
                this.formData1.zrcdschb = resp.accountResp.totalMoneyQOQ.toFixed(2) + '%'
                // 昨日充电度数环比
                this.formData1.zrcddshb = resp.accountResp.totalPowerQOQ.toFixed(2) + '%'
                // 昨日充电次数环比
                this.formData1.zrcdcshb = resp.accountResp.chargeCountQOQ.toFixed(2) + '%'
            } else if (resp.orgType === 3) {

            }
          }
        });
        //   this.$store.dispatch('form/handle', {
        //     url: '/finance/screen/overview',
        //     data: {
        //       companyId: companyId
        //     },
        //     method: 'get',
        //     callback: resp => {
        //       localStorage.setItem('orgType', resp.orgType)
        //       if (resp.orgType === 0) { // 运营商
        //         this.orgType = resp.orgType
        //         console.log();
        //         this.formData = resp.stationResp
        //         const totalPower = this.formData.totalPower
        //         const totalMoney = this.formData.totalMoney
        //         const chargeCount = this.formData.chargeCount
        //         const chargeTime = this.formData.chargeTime
        //         this.stationNumArr = resp.stationResp.topTenList
        //         // 如果数字没超过万，就直接保留两位小数；否则就大额转为数字+单位，如356214转为35.62万，保留两位小数
        //         this.formData.totalPower = this.strNumSize(totalPower) < 5 ? this.retain2(totalPower) : this.unitConvert(totalPower).num + this.unitConvert(totalPower).unit
        //         this.formData.totalMoney = this.strNumSize(totalMoney) < 5 ? this.retain2(totalMoney) : this.unitConvert(totalMoney).num + this.unitConvert(totalMoney).unit
        //         this.formData.chargeCount = this.strNumSize(chargeCount) < 5 ? this.retain2(chargeCount) : this.unitConvert(chargeCount).num + this.unitConvert(chargeCount).unit
        //         this.formData.chargeTime = this.strNumSize(chargeTime) < 5 ? this.retain2(chargeTime) : this.unitConvert(chargeTime).num + this.unitConvert(chargeTime).unit
        //         for (var i = 0; i < resp.stationResp.stationResp.length; i++) {
        //           this.pileCount += (resp.stationResp.stationResp[i].acCount + resp.stationResp.stationResp[i].dcCount)
        //         }
        //         this.stationCount = resp.stationResp.stationResp.length
        //         if (resp.stationResp.stationResp.length > 0) {
        //           this.mapList = resp.stationResp.stationResp
        //         } else {
        //           this.mapList = []
        //         }
        //         console.log(this.mapList, 'mapList')
        //         // this.map()
        //         this.chargingPercent = resp.stationResp.chargingPercent
        //         this.freePercent = resp.stationResp.freePercent
        //         this.faultPercent = resp.stationResp.faultPercent
        //         // this.bt01()
        //         // this.bt02()
        //         // this.bt03()
        //         this.chartsDataX = resp.stationResp.xAxisDate
        //         this.chartsDataY = resp.stationResp.yAxisCount
        //         this.chartsData1X = resp.stationResp.xTodayDate
        //         this.chartsData1Y = resp.stationResp.yTodayCount
        //         for (let i = 0; i < this.chartsDataY.length; i++) {
        //           this.chartsDataY[i] = this.getFloat(this.chartsDataY[i])
        //         }
        //         // this.echarts_04()
        //         // this.echarts_05()
        //       } else if (resp.orgType === 1 || resp.orgType === 2) { // 车辆机构 流量方
        //         this.orgType = resp.orgType
        //         this.formData1 = resp.accountResp
        //         const totalPower = this.formData1.totalPower
        //         const totalMoney = this.formData1.totalMoney
        //         const chargeCount = this.formData1.chargeCount
        //         const chargeTime = this.formData1.chargeTime
        //         // 如果数字没超过万，就直接保留两位小数；否则就大额转为数字+单位，如356214转为35.62万，保留两位小数
        //         this.formData1.totalPower = this.strNumSize(totalPower) < 5 ? this.retain2(totalPower) : this.unitConvert(totalPower).num + this.unitConvert(totalPower).unit
        //         this.formData1.totalMoney = this.strNumSize(totalMoney) < 5 ? this.retain2(totalMoney) : this.unitConvert(totalMoney).num + this.unitConvert(totalMoney).unit
        //         this.formData1.chargeCount = this.strNumSize(chargeCount) < 5 ? this.retain2(chargeCount) : this.unitConvert(chargeCount).num + this.unitConvert(chargeCount).unit
        //         this.formData1.chargeTime = this.strNumSize(chargeTime) < 5 ? this.retain2(chargeTime) : this.unitConvert(chargeTime).num + this.unitConvert(chargeTime).unit
        //         this.topFiveConsumerList = resp.accountResp.topFiveConsumerList
        //         this.chartsDataX = resp.accountResp.xAxisDate
        //         this.chartsDataY = resp.accountResp.yAxisCount
        //         for (let i = 0; i < this.chartsDataY.length; i++) {
        //           this.chartsDataY[i] = this.getFloat(this.chartsDataY[i])
        //         }
        //         // this.echarts_14()
        //         this.mapList = resp.accountResp.mapList
        //         // this.map()
        //         // 昨日充电金额环比
        //         this.formData1.zrcdjehb = resp.accountResp.totalMoneyQOQ.toFixed(2) + '%'
        //         // 昨日充电时长环比
        //         this.formData1.zrcdschb = resp.accountResp.totalMoneyQOQ.toFixed(2) + '%'
        //         // 昨日充电度数环比
        //         this.formData1.zrcddshb = resp.accountResp.totalPowerQOQ.toFixed(2) + '%'
        //         // 昨日充电次数环比
        //         this.formData1.zrcdcshb = resp.accountResp.chargeCountQOQ.toFixed(2) + '%'
        //       } else if (resp.orgType === 3) { // 混合
        //         this.orgType = resp.orgType
        //         this.formData2 = resp.accountResp
        //         this.formData22 = resp.stationResp
        //         const totalPower = this.formData2.totalPower
        //         const totalMoney = this.formData2.totalMoney
        //         const chargeCount = this.formData2.chargeCount
        //         const chargeTime = this.formData2.chargeTime
        //         this.stationNumArr = resp.stationResp.topTenList
        //         // 如果数字没超过万，就直接保留两位小数；否则就大额转为数字+单位，如356214转为35.62万，保留两位小数
        //         this.formData2.totalPower = this.strNumSize(totalPower) < 5 ? this.retain2(totalPower) : this.unitConvert(totalPower).num + this.unitConvert(totalPower).unit
        //         this.formData2.totalMoney = this.strNumSize(totalMoney) < 5 ? this.retain2(totalMoney) : this.unitConvert(totalMoney).num + this.unitConvert(totalMoney).unit
        //         this.formData2.chargeCount = this.strNumSize(chargeCount) < 5 ? this.retain2(chargeCount) : this.unitConvert(chargeCount).num + this.unitConvert(chargeCount).unit
        //         this.formData2.chargeTime = this.strNumSize(chargeTime) < 5 ? this.retain2(chargeTime) : this.unitConvert(chargeTime).num + this.unitConvert(chargeTime).unit
        //         const totalPower22 = this.formData22.totalPower
        //         const totalMoney22 = this.formData22.totalMoney
        //         const chargeCount22 = this.formData22.chargeCount
        //         const chargeTime22 = this.formData22.chargeTime
        //         // 如果数字没超过万，就直接保留两位小数；否则就大额转为数字+单位，如356214转为35.62万，保留两位小数
        //         this.formData22.totalPower = this.strNumSize(totalPower22) < 5 ? this.retain2(totalPower22) : this.unitConvert(totalPower22).num + this.unitConvert(totalPower22).unit
        //         this.formData22.totalMoney = this.strNumSize(totalMoney22) < 5 ? this.retain2(totalMoney22) : this.unitConvert(totalMoney22).num + this.unitConvert(totalMoney22).unit
        //         this.formData22.chargeCount = this.strNumSize(chargeCount22) < 5 ? this.retain2(chargeCount22) : this.unitConvert(chargeCount22).num + this.unitConvert(chargeCount22).unit
        //         this.formData22.chargeTime = this.strNumSize(chargeTime22) < 5 ? this.retain2(chargeTime22) : this.unitConvert(chargeTime22).num + this.unitConvert(chargeTime22).unit
        //         for (let i = 0; i < resp.stationResp.stationResp.length; i++) {
        //           this.pileCount += (resp.stationResp.stationResp[i].acCount + resp.stationResp.stationResp[i].dcCount)
        //         }
        //         this.stationCount = resp.stationResp.stationResp.length
        //         this.mapList = resp.stationResp.stationResp
        //         // this.map()
        //         this.chartsDataX = resp.accountResp.xAxisDate
        //         this.chartsDataY = resp.accountResp.yAxisCount
        //         this.chartsData1X = resp.stationResp.xTodayDate
        //         this.chartsData1Y = resp.stationResp.yTodayCount
        //         for (let i = 0; i < this.chartsDataY.length; i++) {
        //           this.chartsDataY[i] = this.getFloat(this.chartsDataY[i])
        //         }
        //         // this.echarts_34()
        //         // this.echarts_35()
        //         this.chargingPercent = resp.stationResp.chargingPercent
        //         this.freePercent = resp.stationResp.freePercent
        //         this.faultPercent = resp.stationResp.faultPercent
        //         // this.bt31()
        //         // this.bt32()
        //         // this.bt33()
        //       }
        //     }
        //   })
      }
    });


    this.timer2=setInterval(() => {
      
    this.$store.dispatch("form/handle", {
      url: "/user/login/getCurInfo",
      callback: resp => {
        const companyId = resp.companyId;
        //---- 订单总数和当日订单数
        this.$store.dispatch("form/handle", {
          url: "/finance/screen/overviewByOrderByStation",
          data: {
            companyId: companyId,
            loading:false
          },
          method: "get",
          callback: resp => {
            localStorage.setItem("orgType", resp.orgType);
            this.orgType = resp.orgType;
            if (resp.orgType === 0) {
              this.formData.totalOrderCount = resp.stationResp.totalOrderCount;
              this.formData.todayOrderCount = resp.stationResp.todayOrderCount;
            } else if (resp.orgType === 1 || resp.orgType === 2) {
              // this.formData1.totalOrderCount = resp.stationResp.totalOrderCount;
              // this.formData1.todayOrderCount = resp.stationResp.todayOrderCount;
            } else if (resp.orgType === 3) {
              this.formData22.totalOrderCount = resp.stationResp.totalOrderCount;
              this.formData22.todayOrderCount = resp.stationResp.todayOrderCount;
            }
          }
        });
        //----
                this.$store.dispatch("form/handle", {
          url: "/finance/screen/overviewByOrderByAccount",
          data: {
            companyId: companyId,
            loading:false
          },
          method: "get",
          callback: resp => {
            localStorage.setItem("orgType", resp.orgType);
            this.orgType = resp.orgType;
            if (resp.orgType === 0) {
              // this.formData.totalOrderCount = resp.stationResp.totalOrderCount;
              // this.formData.todayOrderCount = resp.stationResp.todayOrderCount;
            } else if (resp.orgType === 1 || resp.orgType === 2) {
              this.formData1.totalOrderCount = resp.accountResp.totalOrderCount;
              this.formData1.todayOrderCount = resp.accountResp.todayOrderCount;
            } else if (resp.orgType === 3) {
              this.formData2.totalOrderCount = resp.accountResp.totalOrderCount;
              this.formData2.todayOrderCount = resp.accountResp.todayOrderCount;
            }
          }
        });
        // ----今日总览和历史总览
        this.$store.dispatch("form/handle", {
          url: "/finance/screen/overviewByLookByStation",
          data: {
            companyId: companyId,
            loading:false
          },
          method: "get",
          callback: resp => {
            const totalPower = resp.stationResp.totalPower;
            const totalMoney = resp.stationResp.totalMoney;
            const chargeCount = resp.stationResp.chargeCount;
            const chargeTime = resp.stationResp.chargeTime;
            if (resp.orgType === 0) {
              this.formData.todayPower = resp.stationResp.todayPower;
              this.formData.todayMoney = resp.stationResp.todayMoney;
              this.formData.carbonEmissions = resp.stationResp.carbonEmissions;
              // 如果数字没超过万，就直接保留两位小数；否则就大额转为数字+单位，如356214转为35.62万，保留两位小数
              this.formData.totalPower =
                this.strNumSize(totalPower) < 5
                  ? this.retain2(totalPower)
                  : this.unitConvert(totalPower).num +
                    this.unitConvert(totalPower).unit;
              this.formData.totalMoney =
                this.strNumSize(totalMoney) < 5
                  ? this.retain2(totalMoney)
                  : this.unitConvert(totalMoney).num +
                    this.unitConvert(totalMoney).unit;
              this.formData.chargeCount =
                this.strNumSize(chargeCount) < 5
                  ? this.retain2(chargeCount)
                  : this.unitConvert(chargeCount).num +
                    this.unitConvert(chargeCount).unit;
              this.formData.chargeTime =
                this.strNumSize(chargeTime) < 5
                  ? this.retain2(chargeTime)
                  : this.unitConvert(chargeTime).num +
                    this.unitConvert(chargeTime).unit;
            } else if (resp.orgType === 1 || resp.orgType === 2) {
              // this.formData1.todayPower = resp.stationResp.todayPower;
              // this.formData1.todayMoney = resp.stationResp.todayMoney;
              // this.formData1.carbonEmissions = resp.stationResp.carbonEmissions;
              // // 如果数字没超过万，就直接保留两位小数；否则就大额转为数字+单位，如356214转为35.62万，保留两位小数
              // this.formData1.totalPower =
              //   this.strNumSize(totalPower) < 5
              //     ? this.retain2(totalPower)
              //     : this.unitConvert(totalPower).num +
              //       this.unitConvert(totalPower).unit;
              // this.formData1.totalMoney =
              //   this.strNumSize(totalMoney) < 5
              //     ? this.retain2(totalMoney)
              //     : this.unitConvert(totalMoney).num +
              //       this.unitConvert(totalMoney).unit;
              // this.formData1.chargeCount =
              //   this.strNumSize(chargeCount) < 5
              //     ? this.retain2(chargeCount)
              //     : this.unitConvert(chargeCount).num +
              //       this.unitConvert(chargeCount).unit;
              // this.formData1.chargeTime =
              //   this.strNumSize(chargeTime) < 5
              //     ? this.retain2(chargeTime)
              //     : this.unitConvert(chargeTime).num +
              //       this.unitConvert(chargeTime).unit;
            } else if (resp.orgType === 3) {
              this.formData22.carbonEmissions =
                resp.stationResp.carbonEmissions;
              this.formData22.todayPower = resp.stationResp.todayPower;
              this.formData22.todayMoney = resp.stationResp.todayMoney;
              // 如果数字没超过万，就直接保留两位小数；否则就大额转为数字+单位，如356214转为35.62万，保留两位小数
              this.formData22.totalPower =
                this.strNumSize(totalPower) < 5
                  ? this.retain2(totalPower)
                  : this.unitConvert(totalPower).num +
                    this.unitConvert(totalPower).unit;
              this.formData22.totalMoney =
                this.strNumSize(totalMoney) < 5
                  ? this.retain2(totalMoney)
                  : this.unitConvert(totalMoney).num +
                    this.unitConvert(totalMoney).unit;
              this.formData22.chargeCount =
                this.strNumSize(chargeCount) < 5
                  ? this.retain2(chargeCount)
                  : this.unitConvert(chargeCount).num +
                    this.unitConvert(chargeCount).unit;
              this.formData22.chargeTime =
                this.strNumSize(chargeTime) < 5
                  ? this.retain2(chargeTime)
                  : this.unitConvert(chargeTime).num +
                    this.unitConvert(chargeTime).unit;
            }
          }
        });
        //----
                this.$store.dispatch("form/handle", {
          url: "/finance/screen/overviewByLookByAccount",
          data: {
            companyId: companyId,
            loading:false
          },
          method: "get",
          callback: resp => {
            const totalPower = resp.accountResp.totalPower;
            const totalMoney = resp.accountResp.totalMoney;
            const chargeCount = resp.accountResp.chargeCount;
            const chargeTime = resp.accountResp.chargeTime;
            if (resp.orgType === 0) {
            } else if (resp.orgType === 1 || resp.orgType === 2) {
              this.formData1.todayPower = resp.accountResp.todayPower;
              this.formData1.todayMoney = resp.accountResp.todayMoney;
              this.formData1.carbonEmissions = resp.accountResp.carbonEmissions;
              // 如果数字没超过万，就直接保留两位小数；否则就大额转为数字+单位，如356214转为35.62万，保留两位小数
              this.formData1.totalPower =
                this.strNumSize(totalPower) < 5
                  ? this.retain2(totalPower)
                  : this.unitConvert(totalPower).num +
                    this.unitConvert(totalPower).unit;
              this.formData1.totalMoney =
                this.strNumSize(totalMoney) < 5
                  ? this.retain2(totalMoney)
                  : this.unitConvert(totalMoney).num +
                    this.unitConvert(totalMoney).unit;
              this.formData1.chargeCount =
                this.strNumSize(chargeCount) < 5
                  ? this.retain2(chargeCount)
                  : this.unitConvert(chargeCount).num +
                    this.unitConvert(chargeCount).unit;
              this.formData1.chargeTime =
                this.strNumSize(chargeTime) < 5
                  ? this.retain2(chargeTime)
                  : this.unitConvert(chargeTime).num +
                    this.unitConvert(chargeTime).unit;
            } else if (resp.orgType === 3) {
              this.formData2.carbonEmissions =
                resp.accountResp.carbonEmissions;
              this.formData2.todayPower = resp.accountResp.todayPower;
              this.formData2.todayMoney = resp.accountResp.todayMoney;
              // 如果数字没超过万，就直接保留两位小数；否则就大额转为数字+单位，如356214转为35.62万，保留两位小数
              this.formData2.totalPower =
                this.strNumSize(totalPower) < 5
                  ? this.retain2(totalPower)
                  : this.unitConvert(totalPower).num +
                    this.unitConvert(totalPower).unit;
              this.formData2.totalMoney =
                this.strNumSize(totalMoney) < 5
                  ? this.retain2(totalMoney)
                  : this.unitConvert(totalMoney).num +
                    this.unitConvert(totalMoney).unit;
              this.formData2.chargeCount =
                this.strNumSize(chargeCount) < 5
                  ? this.retain2(chargeCount)
                  : this.unitConvert(chargeCount).num +
                    this.unitConvert(chargeCount).unit;
              this.formData2.chargeTime =
                this.strNumSize(chargeTime) < 5
                  ? this.retain2(chargeTime)
                  : this.unitConvert(chargeTime).num +
                    this.unitConvert(chargeTime).unit;
            }
          }
        });
        //---- 电站排名+充电终端监控
        this.$store.dispatch("form/handle", {
          url: "/finance/screen/overview",
          data: {
            companyId: companyId,
            loading:false
          },
          method: "get",
          callback: resp => {
            if (resp.orgType === 0) {
              this.stationNumArr = resp.stationResp.topTenList;
              for (var i = 0; i < resp.stationResp.stationResp.length; i++) {
                this.pileCount +=
                  resp.stationResp.stationResp[i].acCount +
                  resp.stationResp.stationResp[i].dcCount;
              }
              this.stationCount = resp.stationResp.stationResp.length;
              if (resp.stationResp.stationResp.length > 0) {
                this.mapList = resp.stationResp.stationResp;
              } else {
                this.mapList = [];
              }
              if(this.mapList.length>0){
                              this.map();
              }
                  this.chargingPercent = resp.stationResp.chargingPercent;
                this.freePercent = resp.stationResp.freePercent;
                this.faultPercent = resp.stationResp.faultPercent;
                if(this.chargingPercent){
                         this.bt01();    
                }
                if(this.freePercent){
                  this.bt02();
                }
                if(this.faultPercent){
                    this.bt03();
                }
            } else if (resp.orgType === 1 || resp.orgType === 2) {
              // this.mapList = resp.accountResp.mapList;
              // this.map();
            } else if (resp.orgType === 3) {
              this.stationNumArr = resp.stationResp.topTenList;
              for (let i = 0; i < resp.stationResp.stationResp.length; i++) {
                this.pileCount +=
                  resp.stationResp.stationResp[i].acCount +
                  resp.stationResp.stationResp[i].dcCount;
              }
              this.stationCount = resp.stationResp.stationResp.length;
              this.mapList = resp.stationResp.stationResp;
              if(this.mapList.length>0){
                            this.map();
              }
                              this.chargingPercent = resp.stationResp.chargingPercent
                this.freePercent = resp.stationResp.freePercent
                this.faultPercent = resp.stationResp.faultPercent
                if(this.chargingPercent){
                  this.bt31()
                }
               if(this.freePercent){
                  this.bt32()
               }
             if( this.faultPercent){
              this.bt33()
             }
              
            }
          }
        });
        //------map
                        this.$store.dispatch("form/handle", {
          url: "/finance/screen/overviewByMapByAccount",
          data: {
            companyId: companyId,
            loading:false
          },
          method: "get",
          callback: resp => {
            if (resp.orgType === 0) {
            } else if (resp.orgType === 1 || resp.orgType === 2) {
              this.mapList = resp.accountResp.mapList;
              if(this.mapList.length>0){
                          this.map();
              }
            
            } else if (resp.orgType === 3) {
            }
          }
        });
        //----近十天用户充电度数
            this.$store.dispatch("form/handle", {
          url: "/finance/screen/overviewByTop10ByStation",
          data: {
            companyId: companyId,
            loading:false
          },
          method: "get",
          callback: resp => {
            if (resp.orgType === 0) {
                  this.chartsDataX = resp.stationResp.xAxisDate;
                this.chartsDataY = resp.stationResp.yAxisCount;
                                for (let i = 0; i < this.chartsDataY.length; i++) {
                  this.chartsDataY[i] = this.getFloat(this.chartsDataY[i])
                }
                if( this.chartsDataX&& this.chartsDataX.length>0){
                                        this.echarts_04()
                }
            } else if (resp.orgType === 1 || resp.orgType === 2) {
                //        this.chartsDataX = resp.accountResp.xAxisDate;
                // this.chartsDataY = resp.accountResp.yAxisCount;
                //   for (let i = 0; i < this.chartsDataY.length; i++) {
                //   this.chartsDataY[i] = this.getFloat(this.chartsDataY[i])
                // }
                //   this.echarts_14()
            } else if (resp.orgType === 3) {
            //      this.chartsDataX = resp.accountResp.xAxisDate
            //     this.chartsDataY = resp.accountResp.yAxisCount
            //       for (let i = 0; i < this.chartsDataY.length; i++) {
            //       this.chartsDataY[i] = this.getFloat(this.chartsDataY[i])
            //     }
            //          this.echarts_34()
            }
          }
        });
        //----------------------------
                    this.$store.dispatch("form/handle", {
          url: "/finance/screen/overviewByTop10ByAccount",
          data: {
            companyId: companyId,
            loading:false
          },
          method: "get",
          callback: resp => {
            if (resp.orgType === 0) {
                //   this.chartsDataX = resp.stationResp.xAxisDate;
                // this.chartsDataY = resp.stationResp.yAxisCount;
                //                 for (let i = 0; i < this.chartsDataY.length; i++) {
                //   this.chartsDataY[i] = this.getFloat(this.chartsDataY[i])
                // }
                // this.echarts_04()
            } else if (resp.orgType === 1 || resp.orgType === 2) {
                       this.chartsDataX = resp.accountResp.xAxisDate;
                this.chartsDataY = resp.accountResp.yAxisCount;
                  for (let i = 0; i < this.chartsDataY.length; i++) {
                  this.chartsDataY[i] = this.getFloat(this.chartsDataY[i])
                }
                  if( this.chartsDataX&& this.chartsDataX.length>0){
                                    this.echarts_14()
                  }
            } else if (resp.orgType === 3) {
                 this.chartsDataX = resp.accountResp.xAxisDate
                this.chartsDataY = resp.accountResp.yAxisCount
                  for (let i = 0; i < this.chartsDataY.length; i++) {
                  this.chartsDataY[i] = this.getFloat(this.chartsDataY[i])
                }
                                  if( this.chartsDataX&& this.chartsDataX.length>0){
                                                      this.echarts_34()
                  }
                
            }
          }
        });
        //----当日实时充电分布
               this.$store.dispatch("form/handle", {
          url: "/finance/screen/overviewByTodayByStation",
          data: {
            companyId: companyId,
            loading:false
          },
          method: "get",
          callback: resp => {
            if (resp.orgType === 0) {
                this.chartsData1X = resp.stationResp.xTodayDate
                this.chartsData1Y = resp.stationResp.yTodayCount
                  if( this.chartsData1X && this.chartsData1X.length>0 ){
                                      this.echarts_05()
                  }

            } else if (resp.orgType === 1 || resp.orgType === 2) {
            } else if (resp.orgType === 3) {
              this.chartsData1X = resp.stationResp.xTodayDate
                this.chartsData1Y = resp.stationResp.yTodayCount
                if( this.chartsData1X && this.chartsData1X.length>0 ){
                this.echarts_35()
                }
            }
          }
        });
        //--------------
               this.$store.dispatch("form/handle", {
          url: "/finance/screen/overviewByQQBByAccount",
          data: {
            companyId: companyId,
            loading:false
          },
          method: "get",
          callback: resp => {
            if (resp.orgType === 0) {

            } else if (resp.orgType === 1 || resp.orgType === 2) {
               // 昨日充电金额环比
                   this.formData1.zrcdjehb = resp.accountResp.totalMoneyQOQ.toFixed(2) + '%'
                // 昨日充电时长环比
                this.formData1.zrcdschb = resp.accountResp.totalMoneyQOQ.toFixed(2) + '%'
                // 昨日充电度数环比
                this.formData1.zrcddshb = resp.accountResp.totalPowerQOQ.toFixed(2) + '%'
                // 昨日充电次数环比
                this.formData1.zrcdcshb = resp.accountResp.chargeCountQOQ.toFixed(2) + '%'
            } else if (resp.orgType === 3) {

            }
          }
        });
        //   this.$store.dispatch('form/handle', {
        //     url: '/finance/screen/overview',
        //     data: {
        //       companyId: companyId
        //     },
        //     method: 'get',
        //     callback: resp => {
        //       localStorage.setItem('orgType', resp.orgType)
        //       if (resp.orgType === 0) { // 运营商
        //         this.orgType = resp.orgType
        //         console.log();
        //         this.formData = resp.stationResp
        //         const totalPower = this.formData.totalPower
        //         const totalMoney = this.formData.totalMoney
        //         const chargeCount = this.formData.chargeCount
        //         const chargeTime = this.formData.chargeTime
        //         this.stationNumArr = resp.stationResp.topTenList
        //         // 如果数字没超过万，就直接保留两位小数；否则就大额转为数字+单位，如356214转为35.62万，保留两位小数
        //         this.formData.totalPower = this.strNumSize(totalPower) < 5 ? this.retain2(totalPower) : this.unitConvert(totalPower).num + this.unitConvert(totalPower).unit
        //         this.formData.totalMoney = this.strNumSize(totalMoney) < 5 ? this.retain2(totalMoney) : this.unitConvert(totalMoney).num + this.unitConvert(totalMoney).unit
        //         this.formData.chargeCount = this.strNumSize(chargeCount) < 5 ? this.retain2(chargeCount) : this.unitConvert(chargeCount).num + this.unitConvert(chargeCount).unit
        //         this.formData.chargeTime = this.strNumSize(chargeTime) < 5 ? this.retain2(chargeTime) : this.unitConvert(chargeTime).num + this.unitConvert(chargeTime).unit
        //         for (var i = 0; i < resp.stationResp.stationResp.length; i++) {
        //           this.pileCount += (resp.stationResp.stationResp[i].acCount + resp.stationResp.stationResp[i].dcCount)
        //         }
        //         this.stationCount = resp.stationResp.stationResp.length
        //         if (resp.stationResp.stationResp.length > 0) {
        //           this.mapList = resp.stationResp.stationResp
        //         } else {
        //           this.mapList = []
        //         }
        //         console.log(this.mapList, 'mapList')
        //         // this.map()
        //         this.chargingPercent = resp.stationResp.chargingPercent
        //         this.freePercent = resp.stationResp.freePercent
        //         this.faultPercent = resp.stationResp.faultPercent
        //         // this.bt01()
        //         // this.bt02()
        //         // this.bt03()
        //         this.chartsDataX = resp.stationResp.xAxisDate
        //         this.chartsDataY = resp.stationResp.yAxisCount
        //         this.chartsData1X = resp.stationResp.xTodayDate
        //         this.chartsData1Y = resp.stationResp.yTodayCount
        //         for (let i = 0; i < this.chartsDataY.length; i++) {
        //           this.chartsDataY[i] = this.getFloat(this.chartsDataY[i])
        //         }
        //         // this.echarts_04()
        //         // this.echarts_05()
        //       } else if (resp.orgType === 1 || resp.orgType === 2) { // 车辆机构 流量方
        //         this.orgType = resp.orgType
        //         this.formData1 = resp.accountResp
        //         const totalPower = this.formData1.totalPower
        //         const totalMoney = this.formData1.totalMoney
        //         const chargeCount = this.formData1.chargeCount
        //         const chargeTime = this.formData1.chargeTime
        //         // 如果数字没超过万，就直接保留两位小数；否则就大额转为数字+单位，如356214转为35.62万，保留两位小数
        //         this.formData1.totalPower = this.strNumSize(totalPower) < 5 ? this.retain2(totalPower) : this.unitConvert(totalPower).num + this.unitConvert(totalPower).unit
        //         this.formData1.totalMoney = this.strNumSize(totalMoney) < 5 ? this.retain2(totalMoney) : this.unitConvert(totalMoney).num + this.unitConvert(totalMoney).unit
        //         this.formData1.chargeCount = this.strNumSize(chargeCount) < 5 ? this.retain2(chargeCount) : this.unitConvert(chargeCount).num + this.unitConvert(chargeCount).unit
        //         this.formData1.chargeTime = this.strNumSize(chargeTime) < 5 ? this.retain2(chargeTime) : this.unitConvert(chargeTime).num + this.unitConvert(chargeTime).unit
        //         this.topFiveConsumerList = resp.accountResp.topFiveConsumerList
        //         this.chartsDataX = resp.accountResp.xAxisDate
        //         this.chartsDataY = resp.accountResp.yAxisCount
        //         for (let i = 0; i < this.chartsDataY.length; i++) {
        //           this.chartsDataY[i] = this.getFloat(this.chartsDataY[i])
        //         }
        //         // this.echarts_14()
        //         this.mapList = resp.accountResp.mapList
        //         // this.map()
        //         // 昨日充电金额环比
        //         this.formData1.zrcdjehb = resp.accountResp.totalMoneyQOQ.toFixed(2) + '%'
        //         // 昨日充电时长环比
        //         this.formData1.zrcdschb = resp.accountResp.totalMoneyQOQ.toFixed(2) + '%'
        //         // 昨日充电度数环比
        //         this.formData1.zrcddshb = resp.accountResp.totalPowerQOQ.toFixed(2) + '%'
        //         // 昨日充电次数环比
        //         this.formData1.zrcdcshb = resp.accountResp.chargeCountQOQ.toFixed(2) + '%'
        //       } else if (resp.orgType === 3) { // 混合
        //         this.orgType = resp.orgType
        //         this.formData2 = resp.accountResp
        //         this.formData22 = resp.stationResp
        //         const totalPower = this.formData2.totalPower
        //         const totalMoney = this.formData2.totalMoney
        //         const chargeCount = this.formData2.chargeCount
        //         const chargeTime = this.formData2.chargeTime
        //         this.stationNumArr = resp.stationResp.topTenList
        //         // 如果数字没超过万，就直接保留两位小数；否则就大额转为数字+单位，如356214转为35.62万，保留两位小数
        //         this.formData2.totalPower = this.strNumSize(totalPower) < 5 ? this.retain2(totalPower) : this.unitConvert(totalPower).num + this.unitConvert(totalPower).unit
        //         this.formData2.totalMoney = this.strNumSize(totalMoney) < 5 ? this.retain2(totalMoney) : this.unitConvert(totalMoney).num + this.unitConvert(totalMoney).unit
        //         this.formData2.chargeCount = this.strNumSize(chargeCount) < 5 ? this.retain2(chargeCount) : this.unitConvert(chargeCount).num + this.unitConvert(chargeCount).unit
        //         this.formData2.chargeTime = this.strNumSize(chargeTime) < 5 ? this.retain2(chargeTime) : this.unitConvert(chargeTime).num + this.unitConvert(chargeTime).unit
        //         const totalPower22 = this.formData22.totalPower
        //         const totalMoney22 = this.formData22.totalMoney
        //         const chargeCount22 = this.formData22.chargeCount
        //         const chargeTime22 = this.formData22.chargeTime
        //         // 如果数字没超过万，就直接保留两位小数；否则就大额转为数字+单位，如356214转为35.62万，保留两位小数
        //         this.formData22.totalPower = this.strNumSize(totalPower22) < 5 ? this.retain2(totalPower22) : this.unitConvert(totalPower22).num + this.unitConvert(totalPower22).unit
        //         this.formData22.totalMoney = this.strNumSize(totalMoney22) < 5 ? this.retain2(totalMoney22) : this.unitConvert(totalMoney22).num + this.unitConvert(totalMoney22).unit
        //         this.formData22.chargeCount = this.strNumSize(chargeCount22) < 5 ? this.retain2(chargeCount22) : this.unitConvert(chargeCount22).num + this.unitConvert(chargeCount22).unit
        //         this.formData22.chargeTime = this.strNumSize(chargeTime22) < 5 ? this.retain2(chargeTime22) : this.unitConvert(chargeTime22).num + this.unitConvert(chargeTime22).unit
        //         for (let i = 0; i < resp.stationResp.stationResp.length; i++) {
        //           this.pileCount += (resp.stationResp.stationResp[i].acCount + resp.stationResp.stationResp[i].dcCount)
        //         }
        //         this.stationCount = resp.stationResp.stationResp.length
        //         this.mapList = resp.stationResp.stationResp
        //         // this.map()
        //         this.chartsDataX = resp.accountResp.xAxisDate
        //         this.chartsDataY = resp.accountResp.yAxisCount
        //         this.chartsData1X = resp.stationResp.xTodayDate
        //         this.chartsData1Y = resp.stationResp.yTodayCount
        //         for (let i = 0; i < this.chartsDataY.length; i++) {
        //           this.chartsDataY[i] = this.getFloat(this.chartsDataY[i])
        //         }
        //         // this.echarts_34()
        //         // this.echarts_35()
        //         this.chargingPercent = resp.stationResp.chargingPercent
        //         this.freePercent = resp.stationResp.freePercent
        //         this.faultPercent = resp.stationResp.faultPercent
        //         // this.bt31()
        //         // this.bt32()
        //         // this.bt33()
        //       }
        //     }
        //   })
      }
    });
        }, 30000);
  }, // 生命周期 - 挂载之前7200000
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {
    var e = document.createEvent("Event");
    e.initEvent("resize", true, true);
    window.dispatchEvent(e);
  }, // 生命周期 - 更新之后
  beforeDestroy() {
    // 在Vue实例销毁前，清除我们的定时器
    if (this.timer) {
      clearInterval(this.timer);
    }
       if (this.timer2) {
      clearInterval(this.timer2);
    }
    if (this.echartsTimer) {
      clearInterval(this.echartsTimer);
    }
    if (this.echartsTimer1) {
      clearInterval(this.echartsTimer1);
    }
  }, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {},
  methods: {
    close() {
      this.$router.push({ path: "./Welcome" });
    },
    /**
     * @param {Object} num
     * 将过万的数字格式化，如 356214 转为 35.62万
     * 返回一个Object，num为数字，unit为单位
     */
    unitConvert(num) {
      var moneyUnits = ["", "万", "亿", "万亿"];
      var dividend = 10000;
      var curentNum = num;
      // 转换数字
      var curentUnit = moneyUnits[0];
      // 转换单位
      for (var i = 0; i < 4; i++) {
        curentUnit = moneyUnits[i];
        if (this.strNumSize(curentNum) < 5) {
          break;
        }
        curentNum = curentNum / dividend;
      }
      var m = { num: 0, unit: "" };
      m.num = curentNum.toFixed(2);
      m.unit = curentUnit;
      return m;
    },
    /**
     * @param {Object} tempNum
     * 返回当前数字的长度，有小数的不计算小数点后面的长度
     */
    strNumSize(tempNum) {
      var stringNum = tempNum.toString();
      var index = stringNum.indexOf(".");
      var newNum = stringNum;
      if (index !== -1) {
        newNum = stringNum.substring(0, index);
      }
      return newNum.length;
    },
    /**
     * @param num
     * 有小数的保留两位小数，无小数的还是不变
     */
    retain2(num) {
      const res = Number(num.toString().match(/^\d+(?:\.\d{0,2})?/));
      return res;
    },
    map() {
      // 基于准备好的dom，初始化echarts实例
      if(document.getElementById("map_1")){
              var myChart = this.$echarts.init(document.getElementById("map_1"));
      this.$echarts.registerMap("china", JSON);
      var toolTipData = [];
      var data = [];
      var geoCoordMap = [];
      if (this.orgType === 1 || this.orgType === 2) {
        for (var i = 0; i < this.mapList.length; i++) {
          toolTipData.push({
            name: this.mapList[i].stationName,
            value: [
              { name: "订单总数", value: this.mapList[i].orderCount },
              { name: "当日订单数", value: this.mapList[i].todayCount }
            ]
          });
          data.push({
            name: this.mapList[i].stationName,
            value: this.mapList[i].orderCount
          });
          geoCoordMap.push({
            name: this.mapList[i].stationName,
            value: [
              this.mapList[i].stationLng,
              this.mapList[i].stationLat,
              this.mapList[i].orderCount
            ]
          });
        }
      } else {
        for (let i = 0; i < this.mapList.length; i++) {
          toolTipData.push({
            name: this.mapList[i].stationName,
            value: [
              { name: "位置", value: this.mapList[i].address },
              { name: "直流枪数量", value:this.mapList[i].xdCount+'/'+this.mapList[i].dcCount },
            this.mapList[i].xaCount>0?{ name: "交流枪数量", value:this.mapList[i].xaCount+'/'+this.mapList[i].acCount }:null
            ]
          });
          data.push({
            name: this.mapList[i].stationName,
            value: this.mapList[i].dcCount + this.mapList[i].acCount
          });
          geoCoordMap.push({
            name: this.mapList[i].stationName,
            value: [
              this.mapList[i].stationLng,
              this.mapList[i].stationLat,
              this.mapList[i].dcCount + this.mapList[i].acCount
            ]
          });
        }
      }
      var convertData = function(data) {
        var res = [];
        for (var i = 0; i < data.length; i++) {
          for (var j = 0; j < geoCoordMap.length; j++) {
            if (data[i].name === geoCoordMap[j].name) {
              res.push({
                name: data[i].name,
                value: geoCoordMap[j].value
              });
            }
          }
        }
        return res;
      };
      // console.log(toolTipData, 9999)
      let option = {};
      option = {
        tooltip: {
          trigger: "item",
          formatter: function(params) {
            if (typeof params.value[2] === "undefined") {
              var toolTiphtml = "";
              for (var i = 0; i < toolTipData.length; i++) {
                if (params.name === toolTipData[i].name) {
                  toolTiphtml += toolTipData[i].name + ":<br>";
            
                  for (var j = 0; j < toolTipData[i].value.length; j++) {
                    if(toolTipData[i].value[j]){
                    toolTiphtml +=
                      toolTipData[i].value[j].name +
                      ":" +
                      toolTipData[i].value[j].value +
                      "<br>";
                    }
                  }
                }
              }
              return toolTiphtml;
            } else {
              let toolTiphtml = "";

              for (let i = 0; i < toolTipData.length; i++) {
                if (params.name === toolTipData[i].name) {
                  toolTiphtml += toolTipData[i].name + ":<br>";

                  for (let j = 0; j < toolTipData[i].value.length; j++) {
                    if(toolTipData[i].value[j]){
                    toolTiphtml +=
                      toolTipData[i].value[j].name +
                      ":" +
                      toolTipData[i].value[j].value +
                      "<br>";
                    }
                  }
                }
              }
              return toolTiphtml;
            }
          }
        },

        geo: {
          map: "china",
          // left: '10%',   //森源
          // top: '10%',
          left: "200%",
          top: "255%",
          label: {
            emphasis: {
              show: false
            }
          },
          roam: true,
          itemStyle: {
            normal: {
              areaColor: "#4c60ff",
              borderColor: "#002097"
            },
            emphasis: {
              areaColor: "#293fff"
            }
          },
          // zoom : 1.2, //缩放
          zoom: 7.1 
        },
        series: [
          {
            name: "",
            type: "effectScatter",
            showEffectOn: "render",
            rippleEffect: {
              brushType: "stroke"
            },
            coordinateSystem: "geo",
            data: convertData(data),
            symbolSize: function(val) {
              if (parseInt(val[2]) > 40) {
                return 40;
              } else {
                return val[2];
              }
            },
            label: {
              normal: {
                formatter: "{b}",
                position: "right",
                show: false
              },
              emphasis: {
                show: false
              }
            },
            itemStyle: {
              normal: {
                color: "#ffeb7b"
              }
            }
          }
        ]
      };

      myChart.setOption(option);
      window.addEventListener("resize", function() {
        myChart.resize();
      });
      myChart.on('click',(e)=>{
  console.log(e,'eeee')
  console.log(toolTipData,'toolTipData')
})
      }
    },
    echarts_34() {
      const newdata = [];
      this.chartsDataY.forEach(item => {
        newdata.push(this.getFixed2(item));
      });
      if(document.getElementById("echart34")){
 var myChart = this.$echarts.init(document.getElementById("echart34"));
      let option1 = {};
      option1 = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        legend: {
          data: ["充电度数"],
          top: "1%",
          textStyle: {
            color: "#fff",
            fontSize: "12"
          }
        },
        grid: {
          left: "10px",
          top: "20px",
          right: "0",
          bottom: "5px",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            data: this.chartsDataX,
            axisLine: {
              show: true,
              lineStyle: {
                color: "rgba(255,255,255,.1)",
                width: 1,
                type: "solid"
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              interval: 0, // 横向信息全部显示
              show: true,
              textStyle: {
                color: "rgba(255,255,255,.6)",
                fontSize: "12"
              },
              rotate: 30 // -30度角倾斜显示
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              show: true,
              textStyle: {
                color: "rgba(255,255,255,.6)",
                fontSize: "12"
              }
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "rgba(255,255,255,.1    )",
                width: 1,
                type: "solid"
              }
            },
            splitLine: {
              lineStyle: {
                color: "rgba(255,255,255,.1)"
              }
            }
          }
        ],
        series: [
          {
            name: "实际充电度数",
            type: "line",
            smooth: true,
            data: newdata,
            barWidth: "15",
            itemStyle: {
              normal: {
                color: "#62c98d",
                opacity: 1,
                barBorderRadius: 5
              }
            }
          }
        ]
      };
      myChart.setOption(option1);
      window.addEventListener("resize", function() {
        myChart.resize();
      });
      }
     
    },
    echarts_35() {
      const newdata = [];
      this.chartsData1Y.forEach(item => {
        newdata.push(parseInt(item));
      });
      if (this.chartsData1X) {
        this.chartsData1X.forEach(item => {
          item = item.slice(11);
          this.xData.push(item);
        });
      } else {
        this.xData = this.chartsData1X;
      }
      this.todayTime = this.dateFormat(new Date()).slice(0, 11);
      if(document.getElementById("echart35")){
   var myChart = this.$echarts.init(document.getElementById("echart35"));
      let option1 = {};
      option1 = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        legend: {
          data: ["充电费用"],
          top: "1%",
          textStyle: {
            color: "#fff",
            fontSize: "12"
          }
        },
        grid: {
          left: "10px",
          top: "20px",
          right: "0",
          bottom: "5px",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            data: this.xData,
            axisLine: {
              show: true,
              lineStyle: {
                color: "rgba(255,255,255,.1)",
                width: 1,
                type: "solid"
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              // interval: 0, // 横向信息全部显示
              show: true,
              textStyle: {
                color: "rgba(255,255,255,.6)",
                fontSize: "12"
              }
              // rotate: 30// -30度角倾斜显示
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              show: true,
              textStyle: {
                color: "rgba(255,255,255,.6)",
                fontSize: "12"
              }
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "rgba(255,255,255,.1    )",
                width: 1,
                type: "solid"
              }
            },
            splitLine: {
              lineStyle: {
                color: "rgba(255,255,255,.1)"
              }
            }
          }
        ],
        series: [
          {
            name: "实时充电订单数",
            type: "line",
            smooth: true,
            data: newdata,
            barWidth: "15",
            itemStyle: {
              normal: {
                color: "#62c98d",
                opacity: 1,
                barBorderRadius: 5
              }
            }
          }
        ]
      };
      myChart.setOption(option1);
      window.addEventListener("resize", function() {
        myChart.resize();
      });
      }
   
    },
    echarts_05() {
      const newdata = [];
      this.chartsData1Y.forEach(item => {
        newdata.push(this.getFixed2(item));
      });
      if(document.getElementById("echart05")){
      var myChart = this.$echarts.init(document.getElementById("echart05"));
      let option1 = {};
      option1 = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        legend: {
          data: ["充电费用"],
          top: "1%",
          textStyle: {
            color: "#fff",
            fontSize: "12"
          }
        },
        grid: {
          left: "10px",
          top: "20px",
          right: "0",
          bottom: "5px",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            data: this.chartsData1X,
            axisLine: {
              show: true,
              lineStyle: {
                color: "rgba(255,255,255,.1)",
                width: 1,
                type: "solid"
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              interval: 0, // 横向信息全部显示
              show: true,
              textStyle: {
                color: "rgba(255,255,255,.6)",
                fontSize: "12"
              },
              rotate: 30 // -30度角倾斜显示
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              show: true,
              textStyle: {
                color: "rgba(255,255,255,.6)",
                fontSize: "12"
              }
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "rgba(255,255,255,.1    )",
                width: 1,
                type: "solid"
              }
            },
            splitLine: {
              lineStyle: {
                color: "rgba(255,255,255,.1)"
              }
            }
          }
        ],
        series: [
          {
            name: "实时充电订单数",
            type: "line",
            smooth: true,
            data: newdata,
            barWidth: "15",
            itemStyle: {
              normal: {
                color: "#62c98d",
                opacity: 1,
                barBorderRadius: 5
              }
            }
          }
        ]
      };
      myChart.setOption(option1);
      window.addEventListener("resize", function() {
        myChart.resize();
      });
      }
    },
    bt31() {
      if(document.getElementById("bt31")){
  var myChart = this.$echarts.init(document.getElementById("bt31"));
      var data1 = this.chargingPercent.split("%"); // 己完成
      var data2 = 100 - parseFloat(data1); // 未完成
      var data3 = this.chargingPercent;
      // console.log(data1, 'data1', data2, 'data2', data3)
      let option = {};
      option = {
        title: [
          {
            text: data3,
            x: "center",
            y: "44%",
            textStyle: {
              fontSize: 18,
              fontWeight: "bold",
              fontStyle: "normal",
              color: "#fff"
            }
          },
          {
            text: "充电",
            x: "center",
            y: "58%",
            textStyle: {
              fontSize: 10,
              fontWeight: "normal",
              fontStyle: "normal",
              color: "rgba(255,255,255,.6)"
            }
          }
        ],
        tooltip: {
          trigger: "item",
          show: false, // 关闭鼠标移上去后显示浮框
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },
        color: ["#0088cc", "#3c446b"],
        series: [
          {
            name: "充电中",
            type: "pie",
            center: ["50%", "55%"],
            radius: ["45%", "60%"],
            startAngle: 360,
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false,
                position: "center"
              },
              emphasis: {
                show: false,
                textStyle: {
                  fontSize: "30",
                  fontWeight: "bold"
                }
              }
            },
            // labelLine: {
            //   normal: {
            //     show: true,
            //   },
            // },
            data: [
              {
                value: data1,
                name: "充电中"
              },
              {
                value: data2,
                name: "未充电"
              }
            ]
          }
        ]
      };
      myChart.setOption(option);
      window.addEventListener("resize", function() {
        myChart.resize();
      });
      }
  
    },
    bt32() {
      if(document.getElementById("bt32")){
var myChart = this.$echarts.init(document.getElementById("bt32"));
      var data1 = this.freePercent.split("%"); // 己完成
      var data2 = 100 - parseFloat(data1); // 未完成
      var data3 = this.freePercent;
      let option = {};
      option = {
        title: [
          {
            text: data3,
            x: "center",
            y: "44%",
            textStyle: {
              fontSize: 18,
              fontWeight: "bold",
              fontStyle: "normal",
              color: "#fff"
            }
          },
          {
            text: "空闲",
            x: "center",
            y: "58%",
            textStyle: {
              fontSize: 10,
              fontWeight: "normal",
              fontStyle: "normal",
              color: "rgba(255,255,255,.6)"
            }
          }
        ],
        tooltip: {
          trigger: "item",
          show: false, // 关闭鼠标移上去后显示浮框
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },
        color: ["#fccb00", "#3b4165"],
        series: [
          {
            name: "空闲",
            type: "pie",
            center: ["50%", "55%"],
            radius: ["45%", "60%"],
            startAngle: 360,
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false,
                position: "center"
              },
              emphasis: {
                show: false,
                textStyle: {
                  fontSize: "30",
                  fontWeight: "bold"
                }
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            data: [
              {
                value: data1,
                name: "空闲"
              },
              {
                value: data2,
                name: "占用"
              }
            ]
          }
        ]
      };
      myChart.setOption(option);
      window.addEventListener("resize", function() {
        myChart.resize();
      });
      }
      
    },
    bt33() {
      if(document.getElementById("bt33")){
   var myChart = this.$echarts.init(document.getElementById("bt33"));
      var data1 = this.faultPercent.split("%"); // 己完成
      var data2 = 100 - parseFloat(data1); // 未完成
      var data3 = this.faultPercent;
      let option = {};
      option = {
        title: [
          {
            text: data3,
            x: "center",
            y: "44%",
            textStyle: {
              fontSize: 18,
              fontWeight: "bold",
              fontStyle: "normal",
              color: "#fff"
            }
          },
          {
            text: "异常",
            x: "center",
            y: "58%",
            textStyle: {
              fontSize: 10,
              fontWeight: "normal",
              fontStyle: "normal",
              color: "rgba(255,255,255,.6)"
            }
          }
        ],
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },
        color: ["#62b62f", "#3b4165"],
        series: [
          {
            name: "异常",
            type: "pie",
            center: ["50%", "55%"],
            radius: ["45%", "60%"],
            startAngle: 360,
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false,
                position: "center"
              },
              emphasis: {
                show: false,
                textStyle: {
                  fontSize: "30",
                  fontWeight: "bold"
                }
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            data: [
              {
                value: data1,
                name: "异常"
              },
              {
                value: data2,
                name: "正常"
              }
            ]
          }
        ]
      };
      myChart.setOption(option);
      window.addEventListener("resize", function() {
        myChart.resize();
      });
      }
  
    },
    echarts_14() {
      const newdata = [];
      this.chartsDataY.forEach(item => {
        newdata.push(this.getFixed2(item));
      });
      if(document.getElementById("echart14")){
   var myChart = this.$echarts.init(document.getElementById("echart14"));
      let option1 = {};
      option1 = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        legend: {
          data: ["充电度数"],
          top: "1%",
          textStyle: {
            color: "#fff",
            fontSize: "12"
          }
        },
        grid: {
          left: "0%",
          top: "20px",
          right: "0%",
          bottom: "0",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            data: this.chartsDataX,
            axisLine: {
              show: true,
              lineStyle: {
                color: "rgba(255,255,255,.1)",
                width: 1,
                type: "solid"
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "rgba(255,255,255,.6)",
                fontSize: "12"
              },
              interval: 0, // 横向信息全部显示
              rotate: 30 // -30度角倾斜显示
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              show: true,
              textStyle: {
                color: "rgba(255,255,255,.6)",
                fontSize: "12"
              }
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "rgba(255,255,255,.1    )",
                width: 1,
                type: "solid"
              }
            },
            splitLine: {
              lineStyle: {
                color: "rgba(255,255,255,.1)"
              }
            }
          }
        ],
        series: [
          {
            name: "实际充电度数",
            type: "line",
            smooth: true,
            data: newdata,
            barWidth: "15",
            itemStyle: {
              normal: {
                color: "#62c98d",
                opacity: 1,
                barBorderRadius: 5
              }
            }
          }
        ]
      };
      myChart.setOption(option1);
      window.addEventListener("resize", function() {
        myChart.resize();
      });
      $(".sebtn a").click(function() {
        $(this)
          .addClass("active")
          .siblings()
          .removeClass("active");
      });
      $(".sebtn a")
        .eq(0)
        .click(function() {
          myChart.setOption(option1);
        });
      }
  
    },
    bt01() {
      if(this.$echarts.init(document.getElementById("bt01"))){
 var myChart = this.$echarts.init(document.getElementById("bt01"));
      var data1 = this.chargingPercent.split("%"); // 己完成
      var data2 = 100 - parseFloat(data1); // 未完成
      var data3 = this.chargingPercent;
      let option = {};
      option = {
        title: [
          {
            text: data3,
            x: "center",
            y: "44%",
            textStyle: {
              fontSize: 18,
              fontWeight: "bold",
              fontStyle: "normal",
              color: "#fff"
            }
          },
          {
            text: "充电中",
            x: "center",
            y: "58%",
            textStyle: {
              fontSize: 10,
              fontWeight: "normal",
              fontStyle: "normal",
              color: "rgba(255,255,255,.6)"
            }
          }
        ],
        tooltip: {
          trigger: "item",
          show: false, // 关闭鼠标移上去后显示浮框
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },
        color: ["#0088cc", "#3c446b"],
        series: [
          {
            name: "检点",
            type: "pie",
            center: ["50%", "55%"],
            radius: ["45%", "60%"],
            startAngle: 360,
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false,
                position: "center"
              },
              emphasis: {
                show: false,
                textStyle: {
                  fontSize: "30",
                  fontWeight: "bold"
                }
              }
            },
            labelLine: {
              normal: {
                show: true
              }
            },
            data: [
              {
                value: data1,
                name: "充电中"
              },
              {
                value: data2,
                name: "未充电"
              }
            ]
          }
        ]
      };
      myChart.setOption(option);
      window.addEventListener("resize", function() {
        myChart.resize();
      });
      }
    
    },
    bt02() {
      if(document.getElementById("bt02")){
 var myChart = this.$echarts.init(document.getElementById("bt02"));
      var data1 = this.freePercent.split("%"); // 己完成
      var data2 = 100 - parseFloat(data1); // 未完成
      var data3 = this.freePercent;
      let option = {};
      option = {
        title: [
          {
            text: data3,
            x: "center",
            y: "44%",
            textStyle: {
              fontSize: 18,
              fontWeight: "bold",
              fontStyle: "normal",
              color: "#fff"
            }
          },
          {
            text: "空闲",
            x: "center",
            y: "58%",
            textStyle: {
              fontSize: 10,
              fontWeight: "normal",
              fontStyle: "normal",
              color: "rgba(255,255,255,.6)"
            }
          }
        ],
        tooltip: {
          trigger: "item",
          show: false, // 关闭鼠标移上去后显示浮框
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },
        color: ["#fccb00", "#3b4165"],
        series: [
          {
            name: "检点",
            type: "pie",
            center: ["50%", "55%"],
            radius: ["45%", "60%"],
            startAngle: 360,
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false,
                position: "center"
              },
              emphasis: {
                show: false,
                textStyle: {
                  fontSize: "30",
                  fontWeight: "bold"
                }
              }
            },
            labelLine: {
              normal: {
                show: true
              }
            },
            data: [
              {
                value: data1,
                name: "空闲"
              },
              {
                value: data2,
                name: "占用"
              }
            ]
          }
        ]
      };
      myChart.setOption(option);
      window.addEventListener("resize", function() {
        myChart.resize();
      });
      }
     
    },
    bt03() {
      if(document.getElementById("bt03")){
   var myChart = this.$echarts.init(document.getElementById("bt03"));
      var data1 = this.faultPercent.split("%"); // 己完成
      var data2 = 100 - parseFloat(data1); // 未完成
      var data3 = this.faultPercent;
      let option = {};
      option = {
        title: [
          {
            text: data3,
            x: "center",
            y: "44%",
            textStyle: {
              fontSize: 18,
              fontWeight: "bold",
              fontStyle: "normal",
              color: "#fff"
            }
          },
          {
            text: "异常",
            x: "center",
            y: "58%",
            textStyle: {
              fontSize: 10,
              fontWeight: "normal",
              fontStyle: "normal",
              color: "rgba(255,255,255,.6)"
            }
          }
        ],
        tooltip: {
          trigger: "item",
          show: false, // 关闭鼠标移上去后显示浮框
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },
        color: ["#62b62f", "#3b4165"],
        series: [
          {
            name: "异常",
            type: "pie",
            center: ["50%", "55%"],
            radius: ["45%", "60%"],
            startAngle: 360,
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false,
                position: "center"
              },
              emphasis: {
                show: false,
                textStyle: {
                  fontSize: "30",
                  fontWeight: "bold"
                }
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            data: [
              {
                value: data1,
                name: "异常"
              },
              {
                value: data2,
                name: "正常"
              }
            ]
          }
        ]
      };
      myChart.setOption(option);
      window.addEventListener("resize", function() {
        myChart.resize();
      });
      }
  
    },
    echarts_04() {
      const newdata = [];
      this.chartsDataY.forEach(item => {
        newdata.push(parseInt(item));
      });
      if(document.getElementById("echart04")){
  var myChart = this.$echarts.init(document.getElementById("echart04"));
      let option1 = {};
      option1 = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        legend: {
          data: ["充电费用"],
          top: "1%",
          textStyle: {
            color: "#fff",
            fontSize: "12"
          }
        },
        grid: {
          left: "0%",
          top: "20px",
          right: "0%",
          bottom: "0",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            data: this.chartsDataX,
            axisLine: {
              show: true,
              lineStyle: {
                color: "rgba(255,255,255,.1)",
                width: 1,
                type: "solid"
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              interval: 0, // 横向信息全部显示
              show: true,
              textStyle: {
                color: "rgba(255,255,255,.6)",
                fontSize: "12"
              },
              rotate: 30 // -30度角倾斜显示
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              show: true,
              textStyle: {
                color: "rgba(255,255,255,.6)",
                fontSize: "12"
              }
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "rgba(255,255,255,.1)",
                width: 1,
                type: "solid"
              }
            },
            splitLine: {
              lineStyle: {
                color: "rgba(255,255,255,.1)"
              }
            }
          }
        ],
        series: [
          {
            name: "充电订单量",
            type: "line",
            smooth: true,
            data: newdata,
            barWidth: "15",
            itemStyle: {
              normal: {
                color: "#62c98d",
                opacity: 1,
                barBorderRadius: 5
              }
            }
          }
        ]
      };
      myChart.setOption(option1);
      window.addEventListener("resize", function() {
        myChart.resize();
      });
      $(".sebtn a").click(function() {
        $(this)
          .addClass("active")
          .siblings()
          .removeClass("active");
      });
      $(".sebtn a")
        .eq(0)
        .click(function() {
          myChart.setOption(option1);
        });
      }
  
    },
    dateFormat(time) {
      var date = new Date(time);
      var year = date.getFullYear();
      var month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var hours =
        date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      var minutes =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      var seconds =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      // 拼接
      return (
        year +
        "-" +
        month +
        "-" +
        day +
        " " +
        hours +
        ":" +
        minutes +
        ":" +
        seconds
      );
    }
  } // 如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style lang="less">
* {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.body {
  padding: 0px;
  margin: 0px;
  color: #222;
  font-family: "微软雅黑";
}
.body {
  background: #000d4a url(../assets/bg.jpg) center center;
  background-size: cover;
  color: #666;
  font-size: 0.1rem;
}
// li {
//   list-style-type: none;
// }
// i {
//   margin: 0px;
//   padding: 0px;
//   text-indent: 0px;
// }
// img {
//   border: none;
//   max-width: 100%;
// }
// a {
//   text-decoration: none;
//   color: #399bff;
// }
a.active,
a:focus {
  outline: none !important;
  text-decoration: none;
}
ol,
ul,
p,
h1,
h2,
h3,
h4,
h5,
h6 {
  padding: 0;
  margin: 0;
}
a:hover {
  color: #06c;
  text-decoration: none !important;
}

// html,
// .body {
//   // height: 100%;
// }
.clearfix:after,
.clearfix:before {
  display: table;
  content: " ";
}
.clearfix:after {
  clear: both;
}
.pulll_left {
  float: left;
}
.counter {
  width: 50%;
  text-align: center;
}
/*谷哥滚动条样式*/

// ::-webkit-scrollbar {
//   width: 5px;
//   height: 5px;
//   position: absolute;
// }
// ::-webkit-scrollbar-thumb {
//   background-color: #5bc0de;
// }
// ::-webkit-scrollbar-track {
//   background-color: #ddd;
// }

/***/

.loading {
  position: fixed;
  left: 0;
  top: 0;
  font-size: 0.3rem;
  z-index: 100000000;
  width: 100%;
  height: 100%;
  background: #1a1a1c;
  text-align: center;
}
.loadbox {
  position: absolute;
  width: 160px;
  height: 150px;
  color: #324e93;
  left: 50%;
  top: 50%;
  margin-top: -100px;
  margin-left: -75px;
}
.loadbox img {
  margin: 10px auto;
  display: block;
  width: 40px;
}

.copyright {
  // line-height: 3rem;
  text-align: center;
  padding-right: 15px;
  // bottom: 0;
  color: rgba(255, 255, 255, 0.5);
  font-size: 0.12rem;
  // position: absolute;
  // left: 0;
  width: 100%;
  // height: 80px;
  min-height: 32px;
  margin-top: 10px;
}

.head {
  height: 100px;
  background: url(../assets/head_bg.png) no-repeat center center;
  background-size: 100% 100%;
  position: relative;
}
.head h1 {
  color: #fff;
  text-align: center;
  font-size: 40px;
  line-height: 76px;
}
.head h1 img {
  width: 1.5rem;
  display: inline-block;
  vertical-align: middle;
}
.time {
  position: absolute;
  right: 70px;
  top: 0;
  line-height: 76px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 18px;
  padding-right: 10px;
  font-family: electronicFont;
}

.mainbox {
  padding: 0 1.2rem 0rem 1.2rem;
  height: 590px;
}
.mainbox > ul {
  margin-left: -0.1rem;
  margin-right: -0.1rem;
  height: 100%;
}
.mainbox > ul > li {
  float: left;
  padding: 0 10px;
  height: 100%;
  width: 30%;
}
.mainbox > ul > li:nth-child(2) {
  width: 40%;
}

.mainbox2 {
  padding: 0 1.2rem 0rem 1.2rem;
  height: 220px;
}
.mainbox2 > ul {
  margin-left: -0.1rem;
  margin-right: -0.1rem;
  height: 220px;
}
.mainbox2 > ul > li {
  float: left;
  padding: 0 10px;
  height: 100%;
  width: 50%;
}

.boxall {
  border: 1px solid rgba(25, 186, 139, 0.17);
  padding: 0 1.2rem 1.2rem 1.2rem;
  background: rgba(255, 255, 255, 0.04) url(../assets/line.png);
  background-size: 100% auto;
  position: relative;
  margin-bottom: 15px;
  z-index: 10;
}
.boxall:before,
.boxall:after {
  position: absolute;
  width: 1.1rem;
  height: 1.1rem;
  content: "";
  border-top: 2px solid #02a6b5;
  top: 0;
}
.boxall:before,
.boxfoot:before {
  border-left: 2px solid #02a6b5;
  left: 0;
}
.boxall:after,
.boxfoot:after {
  border-right: 2px solid #02a6b5;
  right: 0;
}
.alltitle {
  font-size: 1.18rem;
  color: #fff;
  line-height: 2.4rem;
  border-bottom: 1px dotted rgba(255, 255, 255, 0.2);
}
.yesterday-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: calc(100% - 40px);
  li {
    width: 20%;
    p {
      text-align: center;
      color: #999999;
      font-size: 18px;
      padding: 10px 0;
    }
    p:first-child {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      span {
        font-size: 28px;
        padding-left: 10px;
      }
      img {
        width: 75px;
        height: 60px;
      }
    }
  }
}
.boxnav {
  height: 138px;
}

.boxfoot {
  position: absolute;
  bottom: 0;
  width: 100%;
  left: 0;
}
.boxfoot:before,
.boxfoot:after {
  position: absolute;
  width: 1.1rem;
  height: 1.1rem;
  content: "";
  border-bottom: 2px solid #02a6b5;
  bottom: 0;
}

.barnav {
  position: absolute;
  width: 100%;
  z-index: 100;
}
.bar {
  background: rgba(101, 132, 226, 0.1);
  padding: 1.15rem;
}
.barbox li,
.barbox2 li {
  // width: 33.33333%;
  display: flex;
  justify-content: space-around;
  text-align: center;
  position: relative;
}
.barbox:before,
.barbox:after {
  position: absolute;
  width: 1.3rem;
  height: 1.1rem;
  content: "";
}
.barbox:before {
  border-left: 2px solid #02a6b5;
  left: 0;
  border-top: 2px solid #02a6b5;
}
.barbox:after {
  border-right: 2px solid #02a6b5;
  right: 0;
  bottom: 0;
  border-bottom: 2px solid #02a6b5;
}

.barbox li:before {
  position: absolute;
  content: "";
  height: 50%;
  width: 1px;
  background: rgba(255, 255, 255, 0.2);
  right: 0;
  top: 25%;
}

.barbox {
  border: 1px solid rgba(25, 186, 139, 0.17);
  position: relative;
}
.barbox li {
  font-size: 2.5rem;
  color: #ffeb7b;
  padding: 0.05rem 0;
  font-family: Gotham, "Helvetica Neue", Helvetica, Arial, "sans-serif";
  font-weight: bold;
  font-family: electronicFont;
}
.barbox2 li {
  font-size: 1.19rem;
  color: rgba(255, 255, 255, 0.7);
}

.mapbox {
  height: 555px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.map {
  position: relative;
  height: 100%;
  z-index: 9;
  width: 100%;
}
.map4 {
  width: 100%;
  height: calc(100% + 13rem);
  padding-top: 5rem;
  z-index: 999;
}

.map1 {
  width: 31.43rem;
  z-index: 2;
  top: 4rem;
  left: 50%;
  margin-left: -16rem;
  animation: myfirst2 15s infinite linear;
  transform-origin: center 50%;
}
.map2 {
  width: 32.66rem;
  top: 4.5rem;
  left: 50%;
  margin-left: -16rem;
  z-index: 3;
  opacity: 0.2;
  animation: myfirst 10s infinite linear;
}
.map3 {
  width: 31.18rem;
  top: 5.5rem;
  left: 50%;
  margin-left: -16rem;
  z-index: 1;
  transform: scale(0.8);
  opacity: 0.6;
}
.map1,
.map2,
.map3 {
  position: absolute;
}

.wrap {
  overflow: hidden;
}
.wrap li {
  // line-height: 2.42rem;
  // height: 2.42rem;
  height: 56px;
  text-indent: 0.9rem;
  margin-bottom: 0.1rem;
}
.wrap li p {
  border: 1px solid rgba(25, 186, 139, 0.17);
}
.wrap li .divp {
  border: 1px solid rgba(25, 186, 139, 0.17);
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: rgba(255, 255, 255, 0.7);
  height: 80%;
}
.wrap li p {
  display: flex;
  justify-content: space-between;
}
.wrap li p {
  display: flex;
  align-items: center;
  height: 80%;
}
.wrap li p span {
  color: rgba(255, 255, 255, 0.6);
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 20%;
  font-size: 0.16rem;
}
.wrap li p span:first-child {
  width: 40%;
  text-align: left;
}
.station-wrap {
  table {
    width: 100%;
    border-spacing: 0;
    th {
      border-bottom: 2px solid #ffffff33;
      font-size: 16px;
      color: #a7afbf;
    }
    th,
    td {
      padding: 10px;
      text-align: center;
    }
    tr {
      td {
        color: #fff;
        font-size: 14px;
        &:first-child {
          span {
            font-weight: 500;
            padding: 2px 6px;
            border-radius: 2px;
            background: #cccccc;
          }
        }
      }
    }
    tr:nth-child(2) {
      td:first-child {
        span {
          background: #ed405d;
        }
      }
    }
    tr:nth-child(3) {
      td:first-child {
        span {
          background: #f78c44;
        }
      }
    }
    tr:nth-child(4) {
      td:first-child {
        span {
          background: #f9ab77;
        }
      }
    }
    tr:nth-child(5) {
      td:first-child {
        span {
          background: #0099ff;
        }
      }
    }
    tr:nth-child(6) {
      td:first-child {
        span {
          background: #31acff;
        }
      }
    }
    tr:nth-child(7) {
      td:first-child {
        span {
          background: #88cfff;
        }
      }
    }
    tr:nth-child(8) {
      td:first-child {
        span {
          background: #c6e8ff;
        }
      }
    }
  }
  &.less {
    table {
      th,
      td {
        padding: 15px;
      }
    }
  }
}
.carbon-wrap {
  display: flex;
  // align-items: center;
  // justify-content: space-between;
  .carbon-image {
    width: 80px;
    height: 70px;
  }
  .tree-image {
    width: 60px;
    height: 50px;
  }
  .carbon-label {
    font-size: 18px;
    color: #a7afbf;
    margin-left: 20px;
  }
  .carbon-value {
    font-size: 26px;
    color: #008000;
    font-weight: 600;
  }
  .tree-agv {
    color: #008000;
    font-size: 26px;
    margin-right: 15px;
    font-weight: 600;
  }
}
.sycm ul {
  padding: 0.16rem 0;
  width: 100%;
}
.sycm li {
  float: left;
  width: 50%;
  text-align: center;
  position: relative;
}
.sycm li:before {
  position: absolute;
  content: "";
  height: 30%;
  width: 1px;
  background: rgba(255, 255, 255, 0.1);
  right: 0;
  top: 15%;
}
.sycm {
  height: 80%;
  display: flex;
  align-items: center;
}
.sycm li:last-child:before,
.sycm2 li:nth-child(3):before {
  width: 0;
}

.sycm li h2 {
  font-size: 2rem;
  color: #46b8ff;
  padding-bottom: 1.2rem;
}
.sycm.sycmx li h2 {
  font-size: 1.8rem;
  padding-bottom: 0.5rem;
}
.sycm li span {
  font-size: 1.2rem;
  color: #fff;
  opacity: 0.5;
}
.sycm2 {
  height: 90%;
}
.sycm2 li {
  width: 50%;
  padding: 10px 0;
}
.sycm2 li h2 {
  color: #2ad08a;
}

.btbox {
  height: 100%;
}
.btbox li {
  height: 100%;
  float: left;
  width: 30%;
  padding-left: 5%;
}

@keyframes myfirst2 {
  from {
    transform: rotate(0deg) scale(0.8);
  }
  to {
    transform: rotate(359deg) scale(0.8);
  }
}

@keyframes myfirst {
  from {
    transform: rotate(0deg) scale(0.8);
  }
  to {
    transform: rotate(-359deg) scale(0.8);
  }
}

/*Plugin CSS*/
.str_wrap {
  overflow: hidden;
  width: 100%;
  position: relative;
  -moz-user-select: none;
  -khtml-user-select: none;
  user-select: none;
  white-space: nowrap;
}

.str_move {
  white-space: nowrap;
  position: absolute;
  top: 0;
  left: 0;
  cursor: move;
}
.str_move_clone {
  display: inline-block;
  vertical-align: top;
  position: absolute;
  left: 100%;
  top: 0;
}
.str_vertical .str_move_clone {
  left: 0;
  top: 100%;
}
.str_down .str_move_clone {
  left: 0;
  bottom: 100%;
}
.str_vertical .str_move,
.str_down .str_move {
  white-space: normal;
  width: 100%;
}
.str_static .str_move,
.no_drag .str_move,
.noStop .str_move {
  cursor: inherit;
}
.str_wrap img {
  max-width: none !important;
}
.alltitle .sebtn a {
  opacity: 0.6;
  display: inline-block;
  padding: 0 0.1rem;
}
.alltitle .sebtn a.active {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/views/bigScreen.vue